import React from "react";

import "./styles.scss";

export default function Medical02() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="freepik_stories-medicine"
            className="animated"
            version="1.1"
            viewBox="0 0 750 500"
        >
            <g
                id="freepik--background-complete--inject-5"
                style={{
                    WebkitTransformOrigin: 368.941,
                    MsTransformOrigin: 368.941,
                    transformOrigin: 368.941,
                }}
                className="animable animator-hidden"
            >
                <path
                    d="M410.76 55.55a2.59 2.59 0 01-.06.45c-.05.29-.15.72-.23 1.29a37.4 37.4 0 00-.48 5 35.2 35.2 0 00.66 7.92 32.56 32.56 0 003.72 9.8 106.42 106.42 0 007.36 10.46 53.18 53.18 0 017.39 12.75 49.15 49.15 0 013.4 15.91 44.78 44.78 0 01-11.71 32.17 42.41 42.41 0 01-13 9.72c-4.67 2.3-9.32 4-13.42 6a35.1 35.1 0 00-10.31 7.4 34.32 34.32 0 00-8.55 16.14c-.27 1.06-.37 2-.52 2.86s-.17 1.55-.2 2.12 0 1-.07 1.31a3.09 3.09 0 010 .45 3 3 0 010-.45v-1.31c0-.55.1-1.29.16-2.14s.22-1.81.47-2.88a33.35 33.35 0 012.54-7.59 34 34 0 015.94-8.76 35.08 35.08 0 0110.38-7.53c4.13-2.1 8.78-3.79 13.41-6.08a42.09 42.09 0 0012.79-9.56A44.42 44.42 0 00432 119.16a48.85 48.85 0 00-3.33-15.76 53.44 53.44 0 00-7.29-12.66 106.47 106.47 0 01-7.34-10.54 32.35 32.35 0 01-3.68-9.93 34 34 0 01-.58-8 33.18 33.18 0 01.58-5c.1-.57.21-1 .28-1.28z"
                    style={{
                        WebkitTransformOrigin: 403.647,
                        MsTransformOrigin: 403.647,
                        transformOrigin: 403.647,
                    }}
                    id="elfqy8y2gk0d5"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M452.82 62.6a57.44 57.44 0 01-2.06 6.63 52.42 52.42 0 01-3.34 7.43 30.67 30.67 0 01-6.59 8.53 21.26 21.26 0 01-2.47 1.86c-.9.55-1.84 1.06-2.81 1.56l-6.05 3.1c-4.18 2.14-8.67 4.38-13.27 7a48 48 0 00-12.7 10.29 42.47 42.47 0 00-8.59 15.3 38.9 38.9 0 00-1.24 17.47 34.82 34.82 0 006.17 15.09c3.09 4.25 6.73 7.75 9.64 11.46a36.15 36.15 0 013.79 5.68 32.57 32.57 0 012.35 5.84 33.81 33.81 0 011.28 10.71 31.38 31.38 0 01-1.39 8 29.88 29.88 0 01-1.92 4.78c-.27.5-.49.89-.64 1.18s-.24.39-.24.39.06-.15.19-.42.34-.69.6-1.19a33.59 33.59 0 001.82-4.79 31.61 31.61 0 001.28-8 33.47 33.47 0 00-1.33-10.5 32.08 32.08 0 00-2.36-5.76 35.17 35.17 0 00-3.77-5.59c-2.9-3.67-6.55-7.15-9.69-11.45a35.31 35.31 0 01-6.29-15.29 39.47 39.47 0 011.25-17.7 43.12 43.12 0 018.7-15.49A48.42 48.42 0 01416 98.24c4.62-2.57 9.12-4.79 13.31-6.91l6.05-3.08c1-.49 1.92-1 2.8-1.53a21.3 21.3 0 002.43-1.81 30.86 30.86 0 006.58-8.39 55 55 0 003.4-7.36c.8-2.08 1.33-3.73 1.69-4.85.17-.54.31-1 .4-1.28s.16-.43.16-.43z"
                    style={{
                        WebkitTransformOrigin: 422.765,
                        MsTransformOrigin: 422.765,
                        transformOrigin: 422.765,
                    }}
                    id="el3fb26352csd"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M437 87.63c0 .14-4.86-.74-10.78-2s-10.7-2.32-10.67-2.46 4.85.73 10.78 2S437 87.48 437 87.63z"
                    style={{
                        WebkitTransformOrigin: 426.275,
                        MsTransformOrigin: 426.275,
                        transformOrigin: 426.275,
                    }}
                    id="elowvp6rvyet"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M444.33 80.71c0 .14-7.47-1.92-16.6-4.59s-16.49-5-16.45-5.1 7.47 1.92 16.6 4.6 16.49 4.95 16.45 5.09z"
                    style={{
                        WebkitTransformOrigin: 427.805,
                        MsTransformOrigin: 427.805,
                        transformOrigin: 427.805,
                    }}
                    id="elqr0vjemyoph"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M449.7 71.64c0 .13-8.95-2.42-19.89-5.71s-19.81-6.07-19.75-6.21S419 62.14 430 65.43s19.74 6.07 19.7 6.21z"
                    style={{
                        WebkitTransformOrigin: 429.88,
                        MsTransformOrigin: 429.88,
                        transformOrigin: 429.88,
                    }}
                    id="el2pk43fvskeo"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M415.61 155.79c-.05.14-4.83-1.57-10.68-3.82s-10.54-4.18-10.49-4.31 4.83 1.58 10.68 3.82 10.54 4.18 10.49 4.31z"
                    style={{
                        WebkitTransformOrigin: 405.025,
                        MsTransformOrigin: 405.025,
                        transformOrigin: 405.025,
                    }}
                    id="elm8t79sv0wzk"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M425 145a7 7 0 01-1.28-.31c-.82-.22-2-.58-3.44-1-2.88-.91-6.84-2.25-11.17-3.87s-8.21-3.19-11-4.38c-1.39-.6-2.51-1.1-3.28-1.46a7.11 7.11 0 01-1.17-.61 6.66 6.66 0 011.25.42l3.34 1.3c2.81 1.11 6.7 2.63 11 4.25s8.26 3 11.11 4l3.38 1.2a7.15 7.15 0 011.26.46z"
                    style={{
                        WebkitTransformOrigin: 409.33,
                        MsTransformOrigin: 409.33,
                        transformOrigin: 409.33,
                    }}
                    id="elu3y0dgzzglr"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M430.39 133.37a7.54 7.54 0 01-1.38-.52l-3.7-1.53c-3.12-1.3-7.45-3.06-12.28-4.86s-9.26-3.3-12.47-4.36l-3.81-1.26a8.92 8.92 0 01-1.38-.51 7.35 7.35 0 011.44.32c.92.24 2.23.61 3.86 1.1 3.24 1 7.69 2.42 12.54 4.22s9.16 3.62 12.25 5c1.54.69 2.78 1.27 3.63 1.69a7.7 7.7 0 011.3.71z"
                    style={{
                        WebkitTransformOrigin: 412.88,
                        MsTransformOrigin: 412.88,
                        transformOrigin: 412.88,
                    }}
                    id="elrpy76eex9q"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M430.46 118.81a4.36 4.36 0 01-1.1-.31l-2.92-1c-2.47-.86-5.87-2-9.66-3.27s-7.23-2.28-9.73-3l-3-.91a5.15 5.15 0 01-1.07-.39 4.53 4.53 0 011.12.2c.72.15 1.74.41 3 .74 2.53.67 6 1.66 9.79 2.9s7.19 2.47 9.63 3.42c1.21.47 2.19.87 2.86 1.16a5 5 0 011.08.46z"
                    style={{
                        WebkitTransformOrigin: 416.72,
                        MsTransformOrigin: 416.72,
                        transformOrigin: 416.72,
                    }}
                    id="elotz01d2tqza"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M430.6 107.5a93.2 93.2 0 01-9.31-2.89 90.32 90.32 0 01-9.14-3.39 95.05 95.05 0 019.31 2.89 92.66 92.66 0 019.14 3.39z"
                    style={{
                        WebkitTransformOrigin: 421.375,
                        MsTransformOrigin: 421.375,
                        transformOrigin: 421.375,
                    }}
                    id="elky2s39mypa"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M415 177.75a4.61 4.61 0 01-1-.27l-2.64-.89-8.68-3-8.7-2.92-2.64-.91a4.29 4.29 0 01-.95-.39 3.71 3.71 0 011 .2c.64.16 1.56.41 2.69.74 2.26.66 5.36 1.63 8.76 2.79s6.45 2.28 8.64 3.14c1.1.43 2 .79 2.58 1a3.41 3.41 0 01.94.51z"
                    style={{
                        WebkitTransformOrigin: 402.695,
                        MsTransformOrigin: 402.695,
                        transformOrigin: 402.695,
                    }}
                    id="elh8ietzibbqq"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M416.81 191c-.05.13-8.27-2.53-18.36-6s-18.24-6.31-18.19-6.45 8.26 2.53 18.36 6 18.23 6.26 18.19 6.45z"
                    style={{
                        WebkitTransformOrigin: 398.535,
                        MsTransformOrigin: 398.535,
                        transformOrigin: 398.535,
                    }}
                    id="elnk1tnb4gr4"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M416.64 200.77c0 .14-9.22-2.56-20.49-6s-20.39-6.38-20.35-6.52 9.22 2.56 20.5 6 20.39 6.38 20.34 6.52z"
                    style={{
                        WebkitTransformOrigin: 396.22,
                        MsTransformOrigin: 396.22,
                        transformOrigin: 396.22,
                    }}
                    id="el84nd5i87v5"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M250.8 117.58h-.79l-2.3.09c-2 .06-5 .15-8.84.21h-6.4a17.45 17.45 0 01-3.66-.34 37.29 37.29 0 01-3.59-1.67 7.33 7.33 0 00-4.06-.54c-.35.05-.71.14-1.06.21a3.08 3.08 0 00-.93.49 7.41 7.41 0 00-1.51 1.64 42.18 42.18 0 00-4.21 8.77c-1.22 3.21-2.3 6.63-3.59 10.17-.16.44-.34.88-.53 1.32l-.16.33a.62.62 0 01-.11.18.36.36 0 01-.3.18c-.36-.09-.31-.27-.4-.38a2.6 2.6 0 01-.13-.36 21.77 21.77 0 01-.53-2.88c-.26-1.93-.46-3.91-.65-5.92-.73-8-1.31-16.66-2.09-25.7-.41-4.52-.78-9.17-1.57-13.83-.11-.58-.22-1.16-.38-1.73a4.21 4.21 0 00-.29-.78c-.14-.24-.26-.35-.41-.28a3.17 3.17 0 00-1 1.24 16.92 16.92 0 00-.78 1.6 73 73 0 00-2.53 6.94c-1.47 4.71-2.77 9.56-4 14.5l-.47 1.86a12.86 12.86 0 01-.54 1.89 4 4 0 01-3.19 2.34c-1.34.05-2.59.12-3.93.09a18.11 18.11 0 01-3.93-.58 20.06 20.06 0 01-4.67-1.86 11.1 11.1 0 00-2.15-1.08 1.88 1.88 0 00-2 .38 5.77 5.77 0 00-1 2.11c-.25.77-.47 1.55-.69 2.33-.42 1.56-.82 3.13-1.21 4.69-.8 3.12-1.56 6.2-2.55 9.24a1.11 1.11 0 01-.17.32.44.44 0 01-.58.14 1.26 1.26 0 01-.43-.59 9.26 9.26 0 01-.4-1.15c-.21-.77-.38-1.53-.54-2.3-.32-1.53-.59-3.06-.84-4.58-1-6.07-1.82-12-2.7-17.77-.44-2.87-.87-5.71-1.45-8.45a11.22 11.22 0 00-.57-2c-.18-.56-.82.11-1.2.6a26.19 26.19 0 00-2.09 3.49c-2.47 4.82-4.47 9.66-6.7 14.15a23.26 23.26 0 01-1.87 3.24 1.44 1.44 0 01-.82.62 2.54 2.54 0 01-1 0 3.54 3.54 0 01-1.54-1.07 4.9 4.9 0 00-1.36-1 3.08 3.08 0 00-1.58-.34 6 6 0 00-2.86 1.59 3.68 3.68 0 01-1.56.8 1.82 1.82 0 01-.92-.08 2.69 2.69 0 01-.72-.49 18.67 18.67 0 01-2.09-2.51c-.63-.86-1.23-1.71-1.86-2.51a8.36 8.36 0 00-2.11-2c-.82-.54-1.73.14-2.46.66a18.36 18.36 0 00-2 1.88 46.8 46.8 0 00-3.38 4v.06h-.07l-18.27-.07h-6.07a3.33 3.33 0 01-.42 0h6.49l18.27-.07-.11.06a46.66 46.66 0 013.38-4.07 17.4 17.4 0 012.08-1.92 5.52 5.52 0 011.26-.77 2.21 2.21 0 01.78-.16 1.66 1.66 0 01.77.24 8.45 8.45 0 012.22 2.12c.64.81 1.25 1.66 1.88 2.51a17.11 17.11 0 002 2.45 2.52 2.52 0 00.63.43 1.4 1.4 0 00.71.05 3.34 3.34 0 001.39-.73 6.31 6.31 0 013-1.68 4.23 4.23 0 013.26 1.46 3.16 3.16 0 001.36 1 2.05 2.05 0 00.82 0c.18 0 .39-.25.56-.48a22.75 22.75 0 001.82-3.17c2.21-4.47 4.2-9.31 6.68-14.17a25 25 0 012.13-3.56 3.64 3.64 0 01.78-.79.86.86 0 01.65-.2.8.8 0 01.55.45A11 11 0 01161 98c.59 2.77 1 5.61 1.47 8.49.89 5.75 1.71 11.7 2.72 17.76.25 1.52.52 3 .84 4.56.16.76.33 1.51.53 2.26a9.14 9.14 0 00.37 1.08 1.13 1.13 0 00.22.36c-.05 0 0 .15 0 .06s0-.05 0 0a.56.56 0 00.09-.19c1-3 1.74-6.07 2.53-9.18.39-1.56.78-3.13 1.21-4.7.22-.78.44-1.57.7-2.35.12-.39.26-.78.4-1.17a3.38 3.38 0 01.68-1.13 2 2 0 011.21-.64 2.82 2.82 0 011.33.12 10.58 10.58 0 012.26 1.12 19.47 19.47 0 004.55 1.81 18.35 18.35 0 003.82.56c1.26 0 2.6 0 3.85-.09a3.51 3.51 0 002.78-2 13.1 13.1 0 00.51-1.8l.47-1.86c1.26-5 2.57-9.81 4.05-14.53.75-2.36 1.51-4.69 2.48-6.94.25-.56.51-1.11.81-1.65.16-.27.32-.53.51-.79a2.08 2.08 0 01.78-.67.71.71 0 01.66.08 1.2 1.2 0 01.36.43 4 4 0 01.33.89c.16.59.28 1.18.39 1.77.79 4.71 1.15 9.35 1.56 13.87.77 9.06 1.33 17.67 2 25.71.19 2 .38 4 .63 5.91a21.13 21.13 0 00.51 2.81 2.83 2.83 0 00.11.31.67.67 0 00.06.12s-.05 0 0 .08 0-.11-.05-.08a.69.69 0 00.07-.13l.15-.31c.19-.42.36-.86.53-1.3 1.28-3.51 2.38-6.94 3.62-10.15a42.14 42.14 0 014.28-8.84 8 8 0 011.59-1.7 3.1 3.1 0 011-.53 10.65 10.65 0 011.1-.21 7.58 7.58 0 014.21.57c1.27.55 2.36 1.32 3.55 1.69a18.5 18.5 0 003.6.34c2.33.06 4.47 0 6.39 0l8.84-.12h2.3c.57-.13.84-.12.84-.12z"
                    style={{
                        WebkitTransformOrigin: 173.92,
                        MsTransformOrigin: 173.92,
                        transformOrigin: 173.92,
                    }}
                    id="elgmrvbfewgue"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M572.38 206.15h17v106.22a3.88 3.88 0 01-3.88 3.88h-9.26a3.88 3.88 0 01-3.88-3.88V206.15z"
                    style={{
                        WebkitTransformOrigin: 580.87,
                        MsTransformOrigin: 580.87,
                        transformOrigin: 580.87,
                    }}
                    id="elc2rarl3ydng"
                    fill="#E0E0E0"
                    className="animable"
                    transform="rotate(11.56)"
                ></path>
                <path
                    d="M571.64 224.74h17v76.32a3.88 3.88 0 01-3.88 3.88h-9.26a3.88 3.88 0 01-3.88-3.88v-76.32z"
                    style={{
                        WebkitTransformOrigin: 580.13,
                        MsTransformOrigin: 580.13,
                        transformOrigin: 580.13,
                    }}
                    id="elows9v8bmz5d"
                    fill="#F5F5F5"
                    className="animable"
                    transform="rotate(11.55)"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 587.47,
                        MsTransformOrigin: 587.47,
                        transformOrigin: 587.47,
                    }}
                    id="elfz5hbi426n"
                    fill="#FFF"
                    d="M581.8 217.92H593.14V268.39H581.8z"
                    className="animable"
                    transform="rotate(11.55)"
                ></path>
                <path
                    d="M574.39 316.06a4.36 4.36 0 002.18-.24 3.86 3.86 0 001.95-1.75 5.56 5.56 0 00.49-1.63c.12-.61.24-1.26.38-1.94 1.11-5.5 2.7-13.45 4.69-23.33 4-19.79 9.62-47.3 15.91-78.25l.2.3-12.86-2.62-3.8-.78.31-.2c-6.8 33.07-12.91 62.83-17.33 84.35-1.11 5.37-2.12 10.22-3 14.49-.22 1.06-.44 2.09-.64 3.08-.1.49-.21 1-.3 1.46a6.94 6.94 0 00-.22 1.38 3.84 3.84 0 00.83 2.4 3.78 3.78 0 001.94 1.27l6.88 1.47 1.79.39c.4.09.6.15.6.15l-.61-.1-1.8-.34-6.91-1.38a4 4 0 01-3-3.86 7 7 0 01.21-1.44c.09-.47.19-1 .29-1.45.2-1 .4-2 .62-3.09.86-4.27 1.84-9.13 2.93-14.51 4.38-21.52 10.43-51.29 17.17-84.38v-.25l.25.05 3.81.78 12.86 2.63.25.05v.25c-6.36 30.95-12 58.44-16.08 78.22l-4.84 23.29c-.15.69-.28 1.33-.41 1.94a5.45 5.45 0 01-.53 1.67 3.9 3.9 0 01-2 1.77 3.81 3.81 0 01-1.65.24 2.84 2.84 0 01-.56-.09z"
                    style={{
                        WebkitTransformOrigin: 581.265,
                        MsTransformOrigin: 581.265,
                        transformOrigin: 581.265,
                    }}
                    id="elkdkfy50br8a"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M585.42 185.3h16.74a2 2 0 012 2v25.14H583.4v-25.12a2 2 0 012.02-2.02z"
                    style={{
                        WebkitTransformOrigin: 593.78,
                        MsTransformOrigin: 593.78,
                        transformOrigin: 593.78,
                    }}
                    id="el3v06w3085eb"
                    fill="#EBEBEB"
                    className="animable"
                    transform="rotate(11.55)"
                ></path>
                <path
                    d="M601.61 211.63c0 .14-4.62-.68-10.26-1.83s-10.18-2.2-10.15-2.34 4.62.68 10.26 1.83 10.17 2.2 10.15 2.34z"
                    style={{
                        WebkitTransformOrigin: 591.405,
                        MsTransformOrigin: 591.405,
                        transformOrigin: 591.405,
                    }}
                    id="elrc6n3kkyti"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M583.16 207.65c-.15 0 .81-5.28 2.13-11.72s2.5-11.65 2.64-11.62-.82 5.28-2.13 11.72-2.5 11.65-2.64 11.62z"
                    style={{
                        WebkitTransformOrigin: 585.544,
                        MsTransformOrigin: 585.544,
                        transformOrigin: 585.544,
                    }}
                    id="el56i4hlx7cn2"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M585.89 208.21c-.14 0 .81-5.28 2.13-11.72s2.5-11.65 2.64-11.62-.81 5.28-2.13 11.72-2.53 11.65-2.64 11.62z"
                    style={{
                        WebkitTransformOrigin: 588.275,
                        MsTransformOrigin: 588.275,
                        transformOrigin: 588.275,
                    }}
                    id="elwqbtcyilvhe"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M588.71 208.78c-.14 0 .81-5.27 2.13-11.72s2.5-11.64 2.64-11.61-.81 5.27-2.13 11.72-2.5 11.64-2.64 11.61z"
                    style={{
                        WebkitTransformOrigin: 591.095,
                        MsTransformOrigin: 591.095,
                        transformOrigin: 591.095,
                    }}
                    id="el5xcni8zh41e"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M591.44 209.34c-.14 0 .82-5.27 2.13-11.72s2.5-11.64 2.65-11.61-.82 5.27-2.13 11.72-2.5 11.64-2.65 11.61z"
                    style={{
                        WebkitTransformOrigin: 593.831,
                        MsTransformOrigin: 593.831,
                        transformOrigin: 593.831,
                    }}
                    id="elkp283oh7gu9"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M594.26 209.92c-.14 0 .82-5.28 2.13-11.72s2.5-11.65 2.64-11.62-.81 5.28-2.13 11.72-2.5 11.7-2.64 11.62z"
                    style={{
                        WebkitTransformOrigin: 596.645,
                        MsTransformOrigin: 596.645,
                        transformOrigin: 596.645,
                    }}
                    id="elbr2aivfsk89"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M597 210.48c-.14 0 .81-5.28 2.13-11.72s2.5-11.65 2.64-11.62-.81 5.28-2.13 11.72-2.5 11.65-2.64 11.62z"
                    style={{
                        WebkitTransformOrigin: 599.385,
                        MsTransformOrigin: 599.385,
                        transformOrigin: 599.385,
                    }}
                    id="el4tttkzulq04"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M599.82 211.06c-.14 0 .81-5.28 2.13-11.72s2.5-11.65 2.64-11.62-.81 5.27-2.13 11.72-2.46 11.64-2.64 11.62z"
                    style={{
                        WebkitTransformOrigin: 602.205,
                        MsTransformOrigin: 602.205,
                        transformOrigin: 602.205,
                    }}
                    id="elylkx154l9vk"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M623.8 253.91h13.39v82.82a3.88 3.88 0 01-3.88 3.88h-5.64a3.88 3.88 0 01-3.88-3.88v-82.82h.01z"
                    style={{
                        WebkitTransformOrigin: 630.49,
                        MsTransformOrigin: 630.49,
                        transformOrigin: 630.49,
                    }}
                    id="elb3ql4ts0z7d"
                    fill="#E0E0E0"
                    className="animable"
                    transform="rotate(-5.26)"
                ></path>
                <path
                    d="M624.07 268.6h13.39v59.27a3.88 3.88 0 01-3.88 3.88h-5.64a3.88 3.88 0 01-3.88-3.88V268.6h.01z"
                    style={{
                        WebkitTransformOrigin: 630.76,
                        MsTransformOrigin: 630.76,
                        transformOrigin: 630.76,
                    }}
                    id="elkk1s70ov8jn"
                    fill="#F5F5F5"
                    className="animable"
                    transform="rotate(-5.26)"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 631.345,
                        MsTransformOrigin: 631.345,
                        transformOrigin: 631.345,
                    }}
                    id="eledezbphplik"
                    fill="#FFF"
                    d="M626.88 262.29H635.81V302.03000000000003H626.88z"
                    className="animable"
                    transform="rotate(-5.26)"
                ></path>
                <path
                    d="M637.28 340.17a4.69 4.69 0 001.64-.6 3.82 3.82 0 001.39-1.55 3.74 3.74 0 00.38-1.29 7.47 7.47 0 00-.08-1.54c-.42-4.44-1-10.83-1.8-18.77-1.49-15.93-3.56-38.05-5.88-62.91l.28.23-9.47.87-3.86.36.23-.28c2.38 26.19 4.52 49.72 6.06 66.73.38 4.24.72 8.08 1 11.45.16 1.68.27 3.27.43 4.68a3.79 3.79 0 002.37 2.81 6.78 6.78 0 003.08.12l2.3-.19 1.42-.1h.49l-.48.07-1.42.15-2.3.24-1.47.14a3.88 3.88 0 01-1.69-.22 4 4 0 01-2.54-2.95c-.18-1.46-.3-3-.47-4.7-.32-3.37-.69-7.21-1.1-11.45-1.58-17-3.77-40.53-6.22-66.72v-.26h.26l3.86-.36 9.47-.87h.26v.26c2.25 24.87 4.26 47 5.71 62.93.69 7.94 1.25 14.34 1.64 18.78a8.51 8.51 0 01.06 1.58 4 4 0 01-1.89 2.9 3.69 3.69 0 01-1.24.47 3.09 3.09 0 01-.42-.01z"
                    style={{
                        WebkitTransformOrigin: 630.207,
                        MsTransformOrigin: 630.207,
                        transformOrigin: 630.207,
                    }}
                    id="elckqopkrsswc"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M619.86 236.66h12.33a2 2 0 012 2V258h-16.34v-19.33a2 2 0 012.01-2.01z"
                    style={{
                        WebkitTransformOrigin: 626.02,
                        MsTransformOrigin: 626.02,
                        transformOrigin: 626.02,
                    }}
                    id="el04iy7by3l6co"
                    fill="#EBEBEB"
                    className="animable"
                    transform="rotate(-5.26)"
                ></path>
                <path
                    d="M634.82 255.18a128.83 128.83 0 01-16.33 1.5 64.51 64.51 0 018.14-1 62 62 0 018.19-.5z"
                    style={{
                        WebkitTransformOrigin: 626.655,
                        MsTransformOrigin: 626.655,
                        transformOrigin: 626.655,
                    }}
                    id="el0ueqiim2m7el"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M620 256.38a81.51 81.51 0 01-1.12-9.32 81.26 81.26 0 01-.6-9.36 87.28 87.28 0 011.12 9.32 86.93 86.93 0 01.6 9.36z"
                    style={{
                        WebkitTransformOrigin: 619.14,
                        MsTransformOrigin: 619.14,
                        transformOrigin: 619.14,
                    }}
                    id="el35j3lxenxd4"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M622.2 256.18a81.51 81.51 0 01-1.12-9.32 81.26 81.26 0 01-.6-9.36 85.9 85.9 0 011.11 9.31 85.68 85.68 0 01.61 9.37z"
                    style={{
                        WebkitTransformOrigin: 621.34,
                        MsTransformOrigin: 621.34,
                        transformOrigin: 621.34,
                    }}
                    id="eldnztywc7u0r"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M624.45 256a87.28 87.28 0 01-1.12-9.32 86.93 86.93 0 01-.6-9.36 81.51 81.51 0 011.12 9.32 83.94 83.94 0 01.6 9.36z"
                    style={{
                        WebkitTransformOrigin: 623.59,
                        MsTransformOrigin: 623.59,
                        transformOrigin: 623.59,
                    }}
                    id="el0qqqxss38lu"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M626.64 255.77a87.28 87.28 0 01-1.12-9.32 87.06 87.06 0 01-.6-9.36 84.3 84.3 0 011.08 9.31 87 87 0 01.64 9.37z"
                    style={{
                        WebkitTransformOrigin: 625.78,
                        MsTransformOrigin: 625.78,
                        transformOrigin: 625.78,
                    }}
                    id="elnm2swlonchj"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M628.9 255.56a81.51 81.51 0 01-1.12-9.32 81.15 81.15 0 01-.6-9.36 87.28 87.28 0 011.12 9.32 86.93 86.93 0 01.6 9.36z"
                    style={{
                        WebkitTransformOrigin: 628.04,
                        MsTransformOrigin: 628.04,
                        transformOrigin: 628.04,
                    }}
                    id="elc0it3jmw43j"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M631.09 255.36A81.51 81.51 0 01630 246a81.26 81.26 0 01-.6-9.36 87.28 87.28 0 011.12 9.32 86.93 86.93 0 01.57 9.4z"
                    style={{
                        WebkitTransformOrigin: 630.245,
                        MsTransformOrigin: 630.245,
                        transformOrigin: 630.245,
                    }}
                    id="el9g1yz94n09u"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M633.34 255.15a87.29 87.29 0 01-1.12-9.31 87 87 0 01-.6-9.37 81.51 81.51 0 011.12 9.32 81.26 81.26 0 01.6 9.36z"
                    style={{
                        WebkitTransformOrigin: 632.48,
                        MsTransformOrigin: 632.48,
                        transformOrigin: 632.48,
                    }}
                    id="el8x1h9rreo1r"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M233.24 181.63c-1.76-7.82-9.19-14.53-17.16-13.75-4.71.46-9 3.37-11.83 7.12a34.1 34.1 0 00-2.77 4 34.1 34.1 0 00-2.77-4c-2.88-3.76-7.11-6.67-11.82-7.14-8-.79-15.4 5.92-17.18 13.73s1.17 16.11 6 22.51 12.83 14.6 26.41 17.72c8.95-2.06 20.3-11.3 25.12-17.69s7.76-14.69 6-22.5z"
                    style={{
                        WebkitTransformOrigin: 201.471,
                        MsTransformOrigin: 201.471,
                        transformOrigin: 201.471,
                    }}
                    id="elfkq541bztok"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M231.77 196.13h-4.04l-10.95.08.19-.14c-1 3.54-2.11 7.68-3.36 12.22l-.2.74-.25-.72-6.38-18.31c-.71-2-1.4-4.05-2.08-6l.47.05-7.17 12.18-.06.11h-.14l-19.25-.1-5.45-.07h-1.45a1.72 1.72 0 01-.49 0h1.94l5.45-.06 19.25-.09-.2.12 7.11-12.22.28-.49.19.53c.68 2 1.37 4 2.08 6l6.37 18.43h-.46c1.29-4.54 2.45-8.67 3.45-12.2v-.14h.14l10.95.09H231.49z"
                    style={{
                        WebkitTransformOrigin: 201.465,
                        MsTransformOrigin: 201.465,
                        transformOrigin: 201.465,
                    }}
                    id="el2od89x9n1q1"
                    fill="#FAFAFA"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--character-1--inject-5"
                style={{
                    WebkitTransformOrigin: 259.734,
                    MsTransformOrigin: 259.734,
                    transformOrigin: 259.734,
                }}
                className="animable animator-active"
            >
                <path
                    d="M360.55 147.88l-3.42 88.31-44.22-1.43c-.52-5.13-1.1-25-1.1-25s-18.46-2-19.55-20.3c-.53-8.89-.13-27.35.42-44A34 34 0 01327 112.61a34 34 0 0133.55 35.27z"
                    style={{
                        WebkitTransformOrigin: 326.292,
                        MsTransformOrigin: 326.292,
                        transformOrigin: 326.292,
                    }}
                    id="el2gb2wkillcu"
                    fill="#FFBE9D"
                    className="animable"
                ></path>
                <path
                    d="M311.79 209.76a42.7 42.7 0 0023.57-7.92s-5 13.45-23.38 12.67z"
                    style={{
                        WebkitTransformOrigin: 323.575,
                        MsTransformOrigin: 323.575,
                        transformOrigin: 323.575,
                    }}
                    id="el232ydhprq6z"
                    fill="#EB996E"
                    className="animable"
                ></path>
                <path
                    d="M298.69 158.56a2.62 2.62 0 002.65 2.52 2.51 2.51 0 002.59-2.48 2.63 2.63 0 00-2.65-2.53 2.52 2.52 0 00-2.59 2.49z"
                    style={{
                        WebkitTransformOrigin: 301.31,
                        MsTransformOrigin: 301.31,
                        transformOrigin: 301.31,
                    }}
                    id="elu9o7qmk5cpg"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M297.06 154.79c.34.33 2.25-1.23 5.07-1.36s4.95 1.19 5.24.83c.14-.16-.22-.76-1.15-1.38a7.21 7.21 0 00-4.22-1.08 6.9 6.9 0 00-4 1.51c-.84.69-1.11 1.34-.94 1.48z"
                    style={{
                        WebkitTransformOrigin: 302.205,
                        MsTransformOrigin: 302.205,
                        transformOrigin: 302.205,
                    }}
                    id="elnr9mbsinm2h"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M325.38 158.47A2.62 2.62 0 00328 161a2.51 2.51 0 002.59-2.49A2.61 2.61 0 00328 156a2.5 2.5 0 00-2.62 2.47z"
                    style={{
                        WebkitTransformOrigin: 327.985,
                        MsTransformOrigin: 327.985,
                        transformOrigin: 327.985,
                    }}
                    id="eljxhjv8vyy3k"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M324.77 154c.34.32 2.25-1.24 5.07-1.36s5 1.18 5.24.82c.14-.16-.22-.76-1.15-1.37a7.21 7.21 0 00-4.21-1.08 6.83 6.83 0 00-4 1.51c-.85.71-1.12 1.34-.95 1.48z"
                    style={{
                        WebkitTransformOrigin: 329.915,
                        MsTransformOrigin: 329.915,
                        transformOrigin: 329.915,
                    }}
                    id="el7iu0x55v2ht"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M315.53 175.38c0-.16-1.75-.38-4.61-.61-.72 0-1.41-.15-1.55-.64a3.6 3.6 0 01.38-2.15c.59-1.78 1.21-3.63 1.86-5.58 2.59-7.94 4.42-14.45 4.1-14.55S313 158.1 310.45 166q-.93 2.93-1.77 5.6a4.12 4.12 0 00-.24 2.84 1.82 1.82 0 001.23 1 5.09 5.09 0 001.23.11c2.86.06 4.63-.01 4.63-.17z"
                    style={{
                        WebkitTransformOrigin: 312.019,
                        MsTransformOrigin: 312.019,
                        transformOrigin: 312.019,
                    }}
                    id="el3n8k59gkl9g"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M323.91 176.93c-.45 0-.32 3-2.83 5.35s-5.78 2.11-5.79 2.54c0 .19.76.56 2.13.53a7.62 7.62 0 004.84-1.95 6.57 6.57 0 002.18-4.47c.06-1.28-.32-2.03-.53-2z"
                    style={{
                        WebkitTransformOrigin: 319.868,
                        MsTransformOrigin: 319.868,
                        transformOrigin: 319.868,
                    }}
                    id="elqnvqj619c7i"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M323.52 143c.31.76 3.11.26 6.43.5s6 1 6.44.31c.18-.34-.31-1-1.43-1.72a11.23 11.23 0 00-9.81-.62c-1.15.53-1.77 1.18-1.63 1.53z"
                    style={{
                        WebkitTransformOrigin: 329.963,
                        MsTransformOrigin: 329.963,
                        transformOrigin: 329.963,
                    }}
                    id="elklbbemb9r1"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M297.71 146.59c.53.62 2.43-.14 4.77-.28s4.32.23 4.75-.46c.18-.34-.16-1-1.05-1.53a6.94 6.94 0 00-7.67.6c-.79.7-1.03 1.37-.8 1.67z"
                    style={{
                        WebkitTransformOrigin: 302.452,
                        MsTransformOrigin: 302.452,
                        transformOrigin: 302.452,
                    }}
                    id="elk5vralb6nv"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M339.72 129l.11.07a14.49 14.49 0 015.8 9.07c0 .13 0 .25.07.37 1 5.19 1.08 10.52 2.1 15.7s3.07 10.41 7.1 13.82c1.66 1.41 4.51 2.29 5.74.5a4.58 4.58 0 00.54-2.43c.38-12.67 3.29-24 2.65-37.22a11.15 11.15 0 00-5.05-8.84c-2.86-1.85-6.33-3.74-9.33-2.15s-6.71 7.54-9 10.09"
                    style={{
                        WebkitTransformOrigin: 351.821,
                        MsTransformOrigin: 351.821,
                        transformOrigin: 351.821,
                    }}
                    id="el2r535exmz44"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M354.79 156.77c.3-.15 12.41-4.32 12.6 8.23s-12.44 10.15-12.47 9.79-.13-18.02-.13-18.02z"
                    style={{
                        WebkitTransformOrigin: 361.091,
                        MsTransformOrigin: 361.091,
                        transformOrigin: 361.091,
                    }}
                    id="elaa9aez11oto"
                    fill="#FFBE9D"
                    className="animable"
                ></path>
                <path
                    d="M358.68 170c.06 0 .22.15.59.31a2.22 2.22 0 001.64 0c1.32-.51 2.4-2.63 2.43-4.89a7.22 7.22 0 00-.66-3.12 2.53 2.53 0 00-1.67-1.66 1.11 1.11 0 00-1.28.62c-.17.36-.08.61-.15.63s-.27-.21-.18-.73a1.38 1.38 0 01.48-.79 1.68 1.68 0 011.21-.34 3.06 3.06 0 012.31 1.91 7.43 7.43 0 01.81 3.49c0 2.53-1.3 4.91-3.1 5.46a2.34 2.34 0 01-2-.3c-.4-.31-.47-.59-.43-.59z"
                    style={{
                        WebkitTransformOrigin: 361.441,
                        MsTransformOrigin: 361.441,
                        transformOrigin: 361.441,
                    }}
                    id="el398bdymzntg"
                    fill="#EB996E"
                    className="animable"
                ></path>
                <path
                    d="M351.34 121.77c3.62-4.65-4-12.73-10-15.35s-14.37-.49-20.72.87c-4 .86-8.05 2.23-12.1 1.62a27.68 27.68 0 01-7.68-2.88 20.48 20.48 0 00-7.81-2.45c-2.74-.11-5.7 1-7 3.45s-.21 6 2.45 6.71c-3.24-2.28-8.5-.33-9.49 3.51s2.68 8.08 6.62 7.66c-1.62-1.54-4.59.38-4.61 2.62s1.81 4.07 3.75 5.19c5 2.85 11.09 2.78 16.67 1.56s10.88-3.51 16.43-4.87 14.87-3.88 20-1.4c3.8 1.82 6 6.87 8.36 6.06a7.64 7.64 0 004.56-5.17 22.14 22.14 0 00.53-7.13"
                    style={{
                        WebkitTransformOrigin: 315.552,
                        MsTransformOrigin: 315.552,
                        transformOrigin: 315.552,
                    }}
                    id="elt3bkxx81gc"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M289.18 114.65s-.24.11-.63.39a3.73 3.73 0 00-1.28 1.63 5.24 5.24 0 00-.27 3.24 5.39 5.39 0 002.51 3.42 10.31 10.31 0 005.09 1.39 20.4 20.4 0 006.08-.89c4.21-1.22 8.38-3.71 12.78-6.24s8.89-4.64 13.35-5.18a16.5 16.5 0 016.28.39 15.14 15.14 0 015 2.34 15.77 15.77 0 015.13 6 10.93 10.93 0 011 2.73c-.06 0-.3-1-1.15-2.64a16.09 16.09 0 00-5.16-5.76 14.83 14.83 0 00-4.85-2.22 16.08 16.08 0 00-6.12-.33c-4.34.55-8.77 2.65-13.14 5.16s-8.61 5-12.9 6.24a20.35 20.35 0 01-6.24.86 10.44 10.44 0 01-5.27-1.52 6.54 6.54 0 01-1.76-1.67 5.55 5.55 0 01-.47-5.38 3.73 3.73 0 011.41-1.63 2.49 2.49 0 01.61-.33z"
                    style={{
                        WebkitTransformOrigin: 315.448,
                        MsTransformOrigin: 315.448,
                        transformOrigin: 315.448,
                    }}
                    id="elg2wwe86ju16"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M333.51 108.31a2.41 2.41 0 01.82 0 10.18 10.18 0 012.18.39 12.26 12.26 0 018.88 10.65 11.37 11.37 0 010 2.22 2.31 2.31 0 01-.17.79c-.1 0 .07-1.15-.19-3A12.65 12.65 0 00336.4 109c-1.74-.55-2.9-.59-2.89-.69z"
                    style={{
                        WebkitTransformOrigin: 339.477,
                        MsTransformOrigin: 339.477,
                        transformOrigin: 339.477,
                    }}
                    id="eleuxlr4oykjl"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M363.57 140.46a2.17 2.17 0 01-1 .28 4.93 4.93 0 01-2.83-.61 7.23 7.23 0 01-3-3.07 21.13 21.13 0 01-1.72-4.94 20.89 20.89 0 00-1.67-4.83 6.91 6.91 0 00-2.81-2.92 5.08 5.08 0 00-2.66-.66c-.65 0-1 .17-1 .12a2.23 2.23 0 011-.32 4.92 4.92 0 012.84.53 7.14 7.14 0 013.06 3 19.91 19.91 0 011.72 4.96 22.15 22.15 0 001.64 4.84 7.16 7.16 0 002.75 3 5.2 5.2 0 002.64.73c.66-.04 1.02-.16 1.04-.11z"
                    style={{
                        WebkitTransformOrigin: 355.225,
                        MsTransformOrigin: 355.225,
                        transformOrigin: 355.225,
                    }}
                    id="elqp6f2ic191l"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M362.91 148.75s-.1 0-.31.08a6 6 0 01-.9.12 11.1 11.1 0 01-3.34-.26 15 15 0 01-9-6.17 22.29 22.29 0 01-3.69-10.33 9.6 9.6 0 00-.29-1.84 2.24 2.24 0 00-.73-1.12 2 2 0 00-1.08-.41 1.26 1.26 0 011.21.24 2.44 2.44 0 01.87 1.19 9.15 9.15 0 01.38 1.89 23.31 23.31 0 003.76 10.08 15.22 15.22 0 008.62 6.11 17.5 17.5 0 004.5.42z"
                    style={{
                        WebkitTransformOrigin: 353.24,
                        MsTransformOrigin: 353.24,
                        transformOrigin: 353.24,
                    }}
                    id="elp1w11epyvl"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M275.18 465.51l142-.92-14.33-85.82-2.49-147.55-28.36-8.66-14-7.9-46.07 5.83L306 228s-20.16 6.8-28.88 10.79l-.6.27a35.33 35.33 0 00-15.09 13.09L223 311.94l-56.2-32.77L147 308s69 57.44 81.51 56.27 16.85-1.18 21.17-7.06c3.31-4.52 16.32-19.83 22.52-30.06l6.33 70.69z"
                    style={{
                        WebkitTransformOrigin: 282.09,
                        MsTransformOrigin: 282.09,
                        transformOrigin: 282.09,
                    }}
                    id="elikvcek0pyi9"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    d="M320.17 465.6c-.15 0-1.29-31.44-2.54-70.23s-2.17-70.25-2-70.25 1.28 31.43 2.54 70.24 2.14 70.24 2 70.24z"
                    style={{
                        WebkitTransformOrigin: 317.897,
                        MsTransformOrigin: 317.897,
                        transformOrigin: 317.897,
                    }}
                    id="el5zblm9sfb0r"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 335.035,
                        MsTransformOrigin: 335.035,
                        transformOrigin: 335.035,
                    }}
                    id="el4x2ysxe1ssn"
                    fill="#FFBE9D"
                    d="M312.11 219.91L315.68 327.25 357.96 214.66 312.11 219.91z"
                    className="animable"
                ></path>
                <path
                    d="M316 333.3a1.54 1.54 0 01-.14-.33c-.1-.24-.22-.56-.37-1-.35-.88-.83-2.12-1.45-3.71-1.29-3.2-3.18-7.83-5.8-13.42-1.34-2.79-2.84-5.82-4.62-9a49.91 49.91 0 00-6.62-9.34c-1.4-1.44-3.07-2.95-3.66-5.16a6.67 6.67 0 01.08-3.32c.27-1.08.65-2.12 1-3.17 1.39-4.23 2.84-8.6 4.31-13.07l.09-.28.27.34-17 1.54v-.5l9.07-18c2.79-5.48 5.31-10.31 7.48-14.29s4-7.12 5.27-9.23c.65-1.06 1.17-1.87 1.53-2.41l.41-.6c.1-.14.15-.21.16-.2l-.12.22-.38.63c-.34.59-.83 1.4-1.45 2.45-1.25 2.14-3 5.29-5.14 9.29s-4.62 8.84-7.38 14.34l-4.34 8.7-2.33 4.66-1.21 2.4-.63 1.21-.33.6-.17.31-.1.15a.59.59 0 01-.3.24v-.5l17-1.56h.39l-.12.38-.09.27c-1.48 4.47-2.93 8.84-4.32 13.07-.66 2.09-1.62 4.19-1.08 6.21s2.12 3.5 3.52 4.94a49.68 49.68 0 016.67 9.53c1.78 3.18 3.26 6.23 4.58 9 2.58 5.62 4.43 10.28 5.66 13.51.6 1.62 1.06 2.88 1.35 3.74q.23.64.33 1a2.75 2.75 0 01-.02.36z"
                    style={{
                        WebkitTransformOrigin: 299.055,
                        MsTransformOrigin: 299.055,
                        transformOrigin: 299.055,
                    }}
                    id="elc8ch5wtppqm"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M315.86 334.31a1.33 1.33 0 010-.35l.16-1a22.53 22.53 0 011.05-3.84 68.19 68.19 0 016.87-13c1.71-2.6 3.66-5.4 5.87-8.34a105.76 105.76 0 017.5-9A73.42 73.42 0 01347 290a65.94 65.94 0 015.79-3.83c2-1.2 4.1-2.34 6.1-3.67l-.07.36a29.58 29.58 0 00-10.75-9.69l-.36-.19.33-.24a47.94 47.94 0 0121-8.89l-.19.21 2.17-29.84c.28-3.6.5-6.46.66-8.44.08-1 .14-1.7.19-2.23l.06-.57a.55.55 0 010-.2 1 1 0 010 .2v.57c0 .54-.07 1.29-.12 2.24-.12 2-.3 4.84-.52 8.45-.49 7.29-1.17 17.6-2 29.86v.18h-.18a47.61 47.61 0 00-20.79 8.84v-.43a30.06 30.06 0 0110.94 9.85l.15.21-.22.15c-2 1.34-4.12 2.49-6.13 3.69a64.84 64.84 0 00-5.75 3.78 74.51 74.51 0 00-9.62 8.69 104.09 104.09 0 00-7.5 9 155.83 155.83 0 00-5.91 8.28 69.87 69.87 0 00-7 12.85 23.86 23.86 0 00-1.14 3.79c-.09.42-.16.76-.21 1a1.55 1.55 0 01-.07.33z"
                    style={{
                        WebkitTransformOrigin: 343.892,
                        MsTransformOrigin: 343.892,
                        transformOrigin: 343.892,
                    }}
                    id="elh2m38g63g8b"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 354.71,
                        MsTransformOrigin: 354.71,
                        transformOrigin: 354.71,
                    }}
                    id="elmek3h2868ud"
                    fill="#263238"
                    d="M339.78 301.58H369.64V307.39H339.78z"
                    className="animable"
                ></path>
                <path
                    d="M362.9 353.91a1.89 1.89 0 01-.51.15l-1.48.32a44.27 44.27 0 01-5.53.79 19.73 19.73 0 01-8.22-1 13.58 13.58 0 01-7.6-6.59 23.11 23.11 0 01-2.07-9.93c0-3.13.1-5.9.11-8.26s.08-4.25.15-5.57c0-.66.07-1.17.1-1.51a1.74 1.74 0 01.08-.53 3.77 3.77 0 010 .53v15.33a23 23 0 002.06 9.71 13.15 13.15 0 007.29 6.37 19.78 19.78 0 008 1.07 54.12 54.12 0 005.51-.62l1.5-.22a2.61 2.61 0 01.61-.04z"
                    style={{
                        WebkitTransformOrigin: 350.194,
                        MsTransformOrigin: 350.194,
                        transformOrigin: 350.194,
                    }}
                    id="elp99xdgyrwn"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M368.3 321.09c0 .14-6.8.42-15.18.61s-15.19.24-15.19.09 6.79-.41 15.18-.61 15.19-.18 15.19-.09z"
                    style={{
                        WebkitTransformOrigin: 353.115,
                        MsTransformOrigin: 353.115,
                        transformOrigin: 353.115,
                    }}
                    id="ellnlbpmdrl"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M353.51 321.3v-9.91a2.91 2.91 0 012.91-2.91 2.91 2.91 0 012.91 2.91v16.33a1 1 0 01-2 .14v-.39c0-2.49-.28-6.29-.28-6.29z"
                    style={{
                        WebkitTransformOrigin: 356.421,
                        MsTransformOrigin: 356.421,
                        transformOrigin: 356.421,
                    }}
                    id="elbcc3641ypk6"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <path
                    d="M353 338.42a47.72 47.72 0 01-.26-7 47.53 47.53 0 01.26-7 47.53 47.53 0 01.26 7 47.72 47.72 0 01-.26 7z"
                    style={{
                        WebkitTransformOrigin: 353,
                        MsTransformOrigin: 353,
                        transformOrigin: 353,
                    }}
                    id="el9ggtc0cmcob"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M358.63 351.39c-.14 0-.26-5-.26-11.14s.12-11.14.26-11.14.26 5 .26 11.14-.11 11.14-.26 11.14z"
                    style={{
                        WebkitTransformOrigin: 358.63,
                        MsTransformOrigin: 358.63,
                        transformOrigin: 358.63,
                    }}
                    id="elj9iipng3jof"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M312.86 242.49l13.89 16.95c9.81-9.9 16.86-19.68 23-24 0 0-34.06 93.32-34.11 91.77l-2.78-84.72z"
                    style={{
                        WebkitTransformOrigin: 331.305,
                        MsTransformOrigin: 331.305,
                        transformOrigin: 331.305,
                    }}
                    id="ely89ub3pocmi"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <path
                    d="M349.79 235.48a2.69 2.69 0 01-.35.39l-1.08 1c-.94.89-2.28 2.21-3.92 3.85-3.29 3.27-7.66 8-12.43 13.2s-9.2 9.9-12.56 13.12c-1.68 1.61-3.06 2.88-4.05 3.73l-1.14 1a2.28 2.28 0 01-.42.32s.11-.15.35-.39l1.07-1c.95-.89 2.29-2.21 3.93-3.85 3.28-3.27 7.65-8 12.43-13.2s9.2-9.9 12.56-13.12c1.68-1.61 3.06-2.88 4.05-3.73l1.13-1c.27-.23.41-.34.43-.32z"
                    style={{
                        WebkitTransformOrigin: 331.815,
                        MsTransformOrigin: 331.815,
                        transformOrigin: 331.815,
                    }}
                    id="ele4w4fjt2ssp"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M326.66 259.37c-.11.09-3.29-3.61-7.1-8.27s-6.81-8.52-6.7-8.61 3.29 3.61 7.1 8.28 6.81 8.51 6.7 8.6z"
                    style={{
                        WebkitTransformOrigin: 319.76,
                        MsTransformOrigin: 319.76,
                        transformOrigin: 319.76,
                    }}
                    id="elxdsljfxwrms"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M267.62 274.91a3.37 3.37 0 01.12.7c.07.51.15 1.18.25 2 .21 1.75.48 4.28.8 7.42.63 6.27 1.38 14.94 2.16 24.52s1.5 18.2 2 24.53c.26 3.09.47 5.62.62 7.43.07.84.12 1.51.16 2a4.74 4.74 0 010 .71 3.72 3.72 0 01-.13-.7c-.06-.51-.14-1.18-.25-2-.21-1.75-.48-4.28-.79-7.42-.63-6.27-1.39-14.94-2.17-24.52s-1.49-18.2-2-24.53c-.26-3.09-.47-5.62-.63-7.43-.06-.84-.11-1.51-.15-2a3.45 3.45 0 01.01-.71z"
                    style={{
                        WebkitTransformOrigin: 270.67,
                        MsTransformOrigin: 270.67,
                        transformOrigin: 270.67,
                    }}
                    id="eldv1afc8ssa"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M398.31 231s22.26 0 27.84 42.82 17.85 121.35-4.46 136.24S296 423.9 296 423.9v-41.48l84.82-9.36s-.32-7.72 4-7.66L380 267.52s-1-34.66 18.31-36.52z"
                    style={{
                        WebkitTransformOrigin: 365.286,
                        MsTransformOrigin: 365.286,
                        transformOrigin: 365.286,
                    }}
                    id="elqps3xvzqw3r"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    d="M380.22 300.05s0 .4.09 1.18.11 2 .2 3.48c.16 3.07.4 7.55.71 13.29.59 11.51 1.44 28.05 2.48 48.2v.21h-.22a3.11 3.11 0 00-1.95.75 4.61 4.61 0 00-1.2 1.91 13.33 13.33 0 00-.64 4.78v.21h-.2l-83.46 8.59.23-.26v41.51l-.25-.25c36.11.39 67.6-1 89.85-3.85 5.57-.71 10.54-1.52 14.87-2.37a107.9 107.9 0 0010.91-2.75c1.45-.49 2.73-1 3.83-1.39s2-.86 2.71-1.23l1.58-.9.55-.29s-.17.12-.52.33l-1.57.94c-.71.38-1.63.77-2.7 1.28s-2.37.92-3.83 1.42a105.54 105.54 0 01-10.91 2.84c-4.33.88-9.31 1.71-14.87 2.44-22.27 2.89-53.78 4.4-89.91 4h-.25v-.25-41.69h.24l83.46-8.5-.2.23a13.49 13.49 0 01.68-5 5 5 0 011.31-2.07 3.63 3.63 0 012.23-.86l-.2.22c-1-20.15-1.75-36.69-2.29-48.21-.26-5.74-.47-10.22-.61-13.29-.06-1.52-.1-2.68-.14-3.48s-.01-1.17-.01-1.17z"
                    style={{
                        WebkitTransformOrigin: 358.03,
                        MsTransformOrigin: 358.03,
                        transformOrigin: 358.03,
                    }}
                    id="elhsxz0qq5dlh"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M395.7 376.3c-.09 0-.42-.86-1.18-2.16a17.24 17.24 0 00-3.79-4.45 17.48 17.48 0 00-5.07-2.91c-1.41-.51-2.35-.67-2.33-.76a7.1 7.1 0 012.45.41 15.27 15.27 0 019.06 7.53 7 7 0 01.86 2.34z"
                    style={{
                        WebkitTransformOrigin: 389.515,
                        MsTransformOrigin: 389.515,
                        transformOrigin: 389.515,
                    }}
                    id="elce2nrsvwj67"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M385.73 384a23.74 23.74 0 00-6.42-10.37 4.84 4.84 0 011.49 1.08 15.64 15.64 0 012.84 3.42 15.84 15.84 0 011.8 4.06 4.61 4.61 0 01.29 1.81z"
                    style={{
                        WebkitTransformOrigin: 382.522,
                        MsTransformOrigin: 382.522,
                        transformOrigin: 382.522,
                    }}
                    id="elnx1fzfz806"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 187.555,
                        MsTransformOrigin: 187.555,
                        transformOrigin: 187.555,
                    }}
                    id="elirptnz9nxu9"
                    fill="#FF725E"
                    d="M92.67 262.34L153.47 424 282.44 426.61 229.29 263.45 92.67 262.34z"
                    className="animable"
                ></path>
                <g
                    style={{
                        WebkitTransformOrigin: 194.435,
                        MsTransformOrigin: 194.435,
                        transformOrigin: 194.435,
                    }}
                    id="elxrjfije9738"
                    className="animable"
                    opacity="0.5"
                >
                    <path
                        d="M173.88 424.29S143 365 133.41 325.44c-5.47-22.37-10.34-62.9-10.34-62.9l80.5.71s26.7 42.49 42.07 84.95a421 421 0 0120.16 78.11l-41.31-.91-13.59-39.62s-4.24 2.29-10.07-.67l14 40.08z"
                        style={{
                            WebkitTransformOrigin: 194.435,
                            MsTransformOrigin: 194.435,
                            transformOrigin: 194.435,
                        }}
                        id="elnwcksvupd4d"
                        fill="#FFF"
                        className="animable"
                    ></path>
                </g>
                <path
                    d="M218 360.61c-.75-2.18-4-9.88-3.48-13.72s4.32-8 4.53-11.85.32-12.43-.66-16.61a90.1 90.1 0 00-3.79-10.86s-5.83-9.23-11.69-9.44l-7.13-.26s-5.16 1.24-2.66 7.62 8.4 17.33 9.25 19.22 4.83 9.19 3.93 13.87-7.71 17.74-6.81 20.92l-3.65-.13s-3.37-5.84-8.1-8.31-14.88-13.13-17-19.5-4.5-21.19-5.93-25.68-3.64-8.43-7.35-9.43-8.68.26-8.68.26-6.65 2.29-3.68 12.29 4.64 10.61 8.16 16.46 4.41 7.6 7.2 10.14 9.39 5.35 12.23 11.46 4.31 13.2 9.39 21.94 7 12 11 12 5.3-4.53 5.45-7.25a31.76 31.76 0 000-4.29l4.84.18s5.47 10.22 11.21 12.14 5.34-3.24 5.63-5.24-1.42-13.76-2.21-15.93zm-28.35 11.8c-1.52-.78-4.17-5.9-6.8-10.34-2-3.32-1.79-5.07-1.58-5.74a1.25 1.25 0 01.15-.33l-.08.11c.2-1.16 2.15-.65 3.58-.08 1.05.42 6.05 2.37 7.68 9.61s-1.39 7.54-2.92 6.77zm25.08.91c-1 .68-4.37.15-7.72-7.15s.42-8.94 1.21-9.29c1.07-.48 2.72-.86 3.72.34l-.15-.11a3.71 3.71 0 01.38.34 9.33 9.33 0 012.37 5.78c.46 4.35 1.24 9.41.22 10.09z"
                    style={{
                        WebkitTransformOrigin: 182.29,
                        MsTransformOrigin: 182.29,
                        transformOrigin: 182.29,
                    }}
                    id="el3mcj8w8sexw"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M197.55 357c1.2-.08.35-4.64.35-4.64a34.5 34.5 0 000-5.16c-.22-2.15.89-4.12 1.66-6.11s0-7.3-1-10-.3-2.91-.3-2.91c3.08-1 .24-7.41-1.83-13.4s-4.13-5.56-4.13-5.56-1.38-.05-2.17 4.83-2.14 6.61-5.1 6.6h-1.58c-3 0-5.63-2.1-9.83-7.16s-5.57-5.11-5.57-5.11-2.41-.59-.37 5.4 3.57 12.33 7.43 13.61c0 0 .8.28 1.71 3s3.77 8.07 5.94 10.16 4.68 4.2 5.94 6.38 3.61 5.29 3.61 5.29 2.87 4.64 4.15 4.81z"
                    style={{
                        WebkitTransformOrigin: 183.367,
                        MsTransformOrigin: 183.367,
                        transformOrigin: 183.367,
                    }}
                    id="elelua4vsu5yp"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M160.12 264s-1.57.45-.44 3.08 1 4.18 1.65 4.89a23.08 23.08 0 002.2 2s-1.8.62-.47 3.43 1.67 5.58 2.28 6.81 1.9 1.63 2.5 2.34-2-.08-1.32 2.36 2.22 4.22 2.21 6.47 1.09 5.21 3.23 6.32 1.74 2.65 1.8 3.86a19.75 19.75 0 001 4.87c.84 3.13 5.65 8 8.6 7.73s5.78-3.75 5.07-5.85a32.13 32.13 0 00-4.8-7.94c-1.25-1.25-2.31-1.29-2.08-2.66s1.77.75 1.7-1.15a10.21 10.21 0 00-1.46-5.57c-1.19-1.77-1.55-3.5-2.69-5.79s-3.37-2.71-3.19-3.22 1.4-.29.39-2.57-1.07-.73-2.15-4.22-1.57-5.58-2.62-5.27-.89-1.24-1.26-3.67.51-1.53-1-4.17-9.15-2.08-9.15-2.08z"
                    style={{
                        WebkitTransformOrigin: 173.906,
                        MsTransformOrigin: 173.906,
                        transformOrigin: 173.906,
                    }}
                    id="elcpj8e7xbsf7"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M162.14 349.9l1.33-3.18-2.15-6.39s3.6-2.19 8.61 5.08 4.68 10.72 4.68 10.72l-5.94-.21a9.61 9.61 0 00-.21 6.52c1.21 3.28 3 2.88 4.59 8.63a46 46 0 011.77 8.07L193.34 424l-8.27-.3-20-47.53s-2.27-1.47-6-8.68-7.23-16.58-4.84-19.11 7.91 1.52 7.91 1.52z"
                    style={{
                        WebkitTransformOrigin: 173.393,
                        MsTransformOrigin: 173.393,
                        transformOrigin: 173.393,
                    }}
                    id="elg3znxabc52j"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M228.19 352.31l-3.57-3.31-2.23-6.39s-5.22-2.51-5.31 4.57 2.65 10.65 2.65 10.65l5.94.21s3.71 3.44 4.74 6.7-1 2.73 1.28 8.51a61.1 61.1 0 003.78 8.14L247.59 426l8.28.3-12.48-47.3s1.32-1.34.09-8.46-4.08-16.45-8.3-19.22a5 5 0 00-6.99.99z"
                    style={{
                        WebkitTransformOrigin: 236.474,
                        MsTransformOrigin: 236.474,
                        transformOrigin: 236.474,
                    }}
                    id="el2sst1d91fxn"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M92.67 262.34l136.62.89h.15l.05.15c14.93 45.78 32.88 100.84 52.19 160l1 3.11.12.35h-.37l-129-2.63h-.16l-.06-.15-60.54-161.72c.72 1.93 24.85 65.8 61 161.58l-.21-.15 129 2.58-.25.34c-.34-1-.68-2.06-1-3.11l-52.1-160.06.2.15z"
                    style={{
                        WebkitTransformOrigin: 187.735,
                        MsTransformOrigin: 187.735,
                        transformOrigin: 187.735,
                    }}
                    id="elswgi3csaecj"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M296.2 385.8h-12.93s-6.62-6.39-8.42-7.29-10.64-3.57-10.64-3.57l3.41 9.46a14.15 14.15 0 011.57.55c2.26.88 1.63 2.88-.17 2.88H256s-13.34-6.4-15.32-5.23c-1.66 1-2.24 2.75-.54 5.23s13.39 8.31 14.73 8.76l3.82 1.12-3.59 1.12-17-5.93c-1.11-.2-2.63-.38-3.13.26a2.27 2.27 0 00.09 3.28 71.58 71.58 0 007.69 6.05s-2.71 4-.47 6 8.76 8.09 8.76 8.09.68 3.37 2.7 4.94 24.26 1.57 25.83 1.57 10.56-5.16 10.56-5.16l5.88-.62z"
                    style={{
                        WebkitTransformOrigin: 265.257,
                        MsTransformOrigin: 265.257,
                        transformOrigin: 265.257,
                    }}
                    id="el947o45izi7q"
                    fill="#FFBE9D"
                    className="animable"
                ></path>
                <path
                    d="M257.65 408.91a7 7 0 01-2.43.33 7.63 7.63 0 01-2.66-.47 14.5 14.5 0 01-2.89-1.54c-1.93-1.25-3.65-2.41-4.89-3.27a11.29 11.29 0 01-1.93-1.48 11.4 11.4 0 012.14 1.17c1.28.78 3 1.89 5 3.14a16.18 16.18 0 002.78 1.53 7.61 7.61 0 002.5.55c1.44.07 2.38-.05 2.38.04z"
                    style={{
                        WebkitTransformOrigin: 250.25,
                        MsTransformOrigin: 250.25,
                        transformOrigin: 250.25,
                    }}
                    id="eltl4o4mlhklf"
                    fill="#EB996E"
                    className="animable"
                ></path>
                <path
                    d="M258.67 417.23c.05 0-.48.64-1.68.95a6.32 6.32 0 01-4.59-.77 18.85 18.85 0 01-3.72-2.77 5.84 5.84 0 01-1.27-1.44c.12-.14 2.16 2 5.24 3.75a6.44 6.44 0 004.26.87 10.54 10.54 0 001.76-.59z"
                    style={{
                        WebkitTransformOrigin: 253.042,
                        MsTransformOrigin: 253.042,
                        transformOrigin: 253.042,
                    }}
                    id="elcds0bnsi7gk"
                    fill="#EB996E"
                    className="animable"
                ></path>
                <path
                    d="M265 398.82a8.88 8.88 0 01-3.52-.27 9 9 0 01-3.34-1.14 18.94 18.94 0 013.45.63 19.2 19.2 0 013.41.78z"
                    style={{
                        WebkitTransformOrigin: 261.57,
                        MsTransformOrigin: 261.57,
                        transformOrigin: 261.57,
                    }}
                    id="el7u9e8416i3s"
                    fill="#EB996E"
                    className="animable"
                ></path>
                <path
                    d="M87.63 291.57a5.41 5.41 0 01-1.91-7.57 5.93 5.93 0 012-2.17c2.17-1.15 21.37-4.75 23.43-5s2.44 3.67-.25 5.62-23.22 9.14-23.22 9.14z"
                    style={{
                        WebkitTransformOrigin: 98.8517,
                        MsTransformOrigin: 98.8517,
                        transformOrigin: 98.8517,
                    }}
                    id="elgu66cwft495"
                    fill="#FFBE9D"
                    className="animable"
                ></path>
                <path
                    d="M92.1 305.49a5.42 5.42 0 01-1.91-7.55 5.85 5.85 0 012-2.17c2.17-1.15 21.77-6.3 23.43-5 2 1.5 2.44 3.66-.25 5.62s-23.22 9.14-23.22 9.14z"
                    style={{
                        WebkitTransformOrigin: 103.317,
                        MsTransformOrigin: 103.317,
                        transformOrigin: 103.317,
                    }}
                    id="elxy3knhdegu"
                    fill="#FFBE9D"
                    className="animable"
                ></path>
                <path
                    d="M96 302.61a6.33 6.33 0 00-4.23 3.32 4.38 4.38 0 00-.39 2.9 8.31 8.31 0 005.84 6.24c3.51 1.1 14.94-1.47 14.94-1.47l-2.64-7.37 8-2.62c3.26-1.3 1.68-6.4-2.24-5.41-1.28.32-14.7 3.27-19.28 4.41z"
                    style={{
                        WebkitTransformOrigin: 105.282,
                        MsTransformOrigin: 105.282,
                        transformOrigin: 105.282,
                    }}
                    id="elyv5x0h4npz"
                    fill="#FFBE9D"
                    className="animable"
                ></path>
                <path
                    d="M90 298.14a5.41 5.41 0 01-1.91-7.55 5.93 5.93 0 012-2.17c2.17-1.15 19.63-4.26 21.66-4.69s4.21 3.32 1.52 5.27S90 298.14 90 298.14z"
                    style={{
                        WebkitTransformOrigin: 100.899,
                        MsTransformOrigin: 100.899,
                        transformOrigin: 100.899,
                    }}
                    id="elnauaeoa1fh"
                    fill="#FFBE9D"
                    className="animable"
                ></path>
                <path
                    d="M109.73 291.13a19.8 19.8 0 01-3.06.78c-1.9.42-4.53 1-7.44 1.54a19.17 19.17 0 00-7 2.57A11.46 11.46 0 0090 298.2s.08-.3.37-.77a6.7 6.7 0 011.6-1.71 11.75 11.75 0 013-1.64 28.33 28.33 0 014.06-1.14c2.92-.58 5.57-1.06 7.49-1.39a18.35 18.35 0 013.21-.42z"
                    style={{
                        WebkitTransformOrigin: 99.865,
                        MsTransformOrigin: 99.865,
                        transformOrigin: 99.865,
                    }}
                    id="el5xd1stdgtk8"
                    fill="#EB996E"
                    className="animable"
                ></path>
                <path
                    d="M106.36 284.75a17.17 17.17 0 01-2.93.71l-7.13 1.38a17.23 17.23 0 00-6.63 2.59 14.26 14.26 0 00-2 2.14s.08-.29.35-.74a6.74 6.74 0 011.46-1.69c1.45-1.28 4-2.2 6.75-2.8s5.33-.94 7.17-1.24a17.69 17.69 0 012.96-.35z"
                    style={{
                        WebkitTransformOrigin: 97.015,
                        MsTransformOrigin: 97.015,
                        transformOrigin: 97.015,
                    }}
                    id="elr5x8ix484v"
                    fill="#EB996E"
                    className="animable"
                ></path>
                <path
                    d="M110 299.3a16.84 16.84 0 01-2.75.84c-1.71.46-4.1 1.07-6.76 1.51a17.8 17.8 0 00-6.49 2.16 11.33 11.33 0 00-2 1.91s.07-.27.35-.69a6.44 6.44 0 011.51-1.52 16.24 16.24 0 016.54-2.37c2.67-.44 5-1 6.78-1.35a15.33 15.33 0 012.82-.49z"
                    style={{
                        WebkitTransformOrigin: 101,
                        MsTransformOrigin: 101,
                        transformOrigin: 101,
                    }}
                    id="elyrtxxdvxe1g"
                    fill="#EB996E"
                    className="animable"
                ></path>
                <path
                    d="M111.08 305.72a20 20 0 01-4.17 1.67 19.94 19.94 0 01-4.36 1.17 19.43 19.43 0 014.17-1.66 20 20 0 014.36-1.18z"
                    style={{
                        WebkitTransformOrigin: 106.815,
                        MsTransformOrigin: 106.815,
                        transformOrigin: 106.815,
                    }}
                    id="el1v7o4auv5lz"
                    fill="#EB996E"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--character-2--inject-5"
                style={{
                    WebkitTransformOrigin: 484.015,
                    MsTransformOrigin: 484.015,
                    transformOrigin: 484.015,
                }}
                className="animable"
            >
                <path
                    d="M519.31 190.26a13.9 13.9 0 1116.91 20.64 9.36 9.36 0 01-8.07 16.89c-1.09 3.84-5.39 6.16-9.37 5.89s-7.57-2.63-10.29-5.55a25.15 25.15 0 01-6.07-23c2.12-8 9-14.7 17.21-16.08"
                    style={{
                        WebkitTransformOrigin: 523.207,
                        MsTransformOrigin: 523.207,
                        transformOrigin: 523.207,
                    }}
                    id="elnweqc0kszf"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M525.63 184s.07.09.17.28a7.17 7.17 0 01.38.86 12.35 12.35 0 01.77 3.44 13.89 13.89 0 01-.59 5.33 13.44 13.44 0 01-3.57 5.78v-.33a14.65 14.65 0 012.65 6.37 14.23 14.23 0 01-6.63 14.6 14.14 14.14 0 01-4.74 1.89 9.91 9.91 0 01-1.37.18 2.6 2.6 0 01-.49 0c0-.06.66-.11 1.82-.38a15.41 15.41 0 004.58-2 14.31 14.31 0 003.78-20.37l-.13-.18.16-.15a13 13 0 003.5-5.54 13.93 13.93 0 00.69-5.18 16.75 16.75 0 00-.98-4.6z"
                    style={{
                        WebkitTransformOrigin: 519.605,
                        MsTransformOrigin: 519.605,
                        transformOrigin: 519.605,
                    }}
                    id="el07m3u1nbakb6"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M565.62 181.22a11.21 11.21 0 01-1.48.88c-1 .53-2.38 1.28-4.13 2.18-3.52 1.81-8.42 4.2-13.93 6.66s-10.57 4.5-14.26 5.91c-1.84.7-3.34 1.26-4.39 1.62a11.56 11.56 0 01-1.63.51 10.66 10.66 0 011.56-.7l4.33-1.77c3.65-1.5 8.68-3.6 14.18-6s10.42-4.79 14-6.51l4.21-2a11.36 11.36 0 011.54-.78z"
                    style={{
                        WebkitTransformOrigin: 545.71,
                        MsTransformOrigin: 545.71,
                        transformOrigin: 545.71,
                    }}
                    id="el3wnfxsidv2q"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <path
                    d="M552.59 168.26c.09.11-5.4 5.36-12.27 11.72s-12.52 11.45-12.62 11.34 5.4-5.32 12.3-11.72 12.49-11.44 12.59-11.34z"
                    style={{
                        WebkitTransformOrigin: 540.145,
                        MsTransformOrigin: 540.145,
                        transformOrigin: 540.145,
                    }}
                    id="elmmt86uh8h2m"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <path
                    d="M492.79 146.6c0-10.76-12.86-11.29-19.36-8.6-3.5-4.8-6-7.22-14.05-7.72-5.91-.38-14.92 2.59-19.46 8.54a21.47 21.47 0 00-2.42 21.27c1 2.27 2.43 4.55 2.15 7-.41 3.56-4.06 5.64-6.42 8.33a13.59 13.59 0 00-.64 16.63c2.29 3 5.93 5.17 7.14 8.77 1 3 .06 6.31.25 9.49.35 5.85 4.79 11 10.23 13.11s11.67 1.64 17.17-.36"
                    style={{
                        WebkitTransformOrigin: 461.423,
                        MsTransformOrigin: 461.423,
                        transformOrigin: 461.423,
                    }}
                    id="el1km8n748v9k"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M445.75 259.47l20.17-9 .69-13.49s-15.16-2.24-18.65-21.9c-1.73-9.78-1.52-25.87-.93-39 .54-11.85 13.08-23.89 24.89-22.85l38.36 6.59v6.37l.35 81.24 19.84 9.57-45 53.16z"
                    style={{
                        WebkitTransformOrigin: 488.11,
                        MsTransformOrigin: 488.11,
                        transformOrigin: 488.11,
                    }}
                    id="el4k1eqysbdd"
                    fill="#A36957"
                    className="animable"
                ></path>
                <path
                    d="M454.2 190a2.52 2.52 0 002.48 2.5 2.43 2.43 0 002.57-2.32 2.53 2.53 0 00-2.48-2.51 2.42 2.42 0 00-2.57 2.33z"
                    style={{
                        WebkitTransformOrigin: 456.725,
                        MsTransformOrigin: 456.725,
                        transformOrigin: 456.725,
                    }}
                    id="elii8i64lk0tc"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M450.67 184.32c.32.32 2.21-1.13 4.93-1.17s4.74 1.29 5 .95c.15-.15-.18-.74-1.06-1.36a7 7 0 00-4-1.17 6.65 6.65 0 00-3.92 1.35c-.83.65-1.11 1.25-.95 1.4z"
                    style={{
                        WebkitTransformOrigin: 455.631,
                        MsTransformOrigin: 455.631,
                        transformOrigin: 455.631,
                    }}
                    id="el82efi9z0o15"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M479.63 190a2.52 2.52 0 002.48 2.51 2.43 2.43 0 002.57-2.33 2.54 2.54 0 00-2.48-2.51 2.42 2.42 0 00-2.57 2.33z"
                    style={{
                        WebkitTransformOrigin: 482.155,
                        MsTransformOrigin: 482.155,
                        transformOrigin: 482.155,
                    }}
                    id="el4f4yxwfgoid"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M477.43 184.35c.32.33 2.22-1.13 4.94-1.17s4.74 1.29 5 .95c.14-.15-.19-.74-1.07-1.36a7 7 0 00-4-1.16 6.66 6.66 0 00-3.92 1.34c-.83.66-1.1 1.26-.95 1.4z"
                    style={{
                        WebkitTransformOrigin: 482.396,
                        MsTransformOrigin: 482.396,
                        transformOrigin: 482.396,
                    }}
                    id="elsiev2oj4gmq"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M467.92 204.71c0-.15-1.69-.41-4.44-.72-.7-.06-1.36-.18-1.48-.65a3.5 3.5 0 01.43-2.07c.62-1.7 1.27-3.47 2-5.33 2.72-7.59 4.67-13.82 4.37-13.93s-2.76 6-5.48 13.54c-.66 1.87-1.28 3.66-1.88 5.36a4.05 4.05 0 00-.31 2.74 1.75 1.75 0 001.16 1 4.94 4.94 0 001.18.15c2.73.08 4.44.07 4.45-.09z"
                    style={{
                        WebkitTransformOrigin: 464.925,
                        MsTransformOrigin: 464.925,
                        transformOrigin: 464.925,
                    }}
                    id="elsmypx3g4nui"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M466.61 237a50.17 50.17 0 0026.28-7.51s-6.76 13.9-26.53 12.41z"
                    style={{
                        WebkitTransformOrigin: 479.625,
                        MsTransformOrigin: 479.625,
                        transformOrigin: 479.625,
                    }}
                    id="el6w7mg1125dx"
                    fill="#7C3B29"
                    className="animable"
                ></path>
                <path
                    d="M469.18 211.25a4.93 4.93 0 014.37-1.9 4.54 4.54 0 013.12 1.6 2.85 2.85 0 01.27 3.25 3.28 3.28 0 01-3.55 1 10.42 10.42 0 01-3.52-2 3.12 3.12 0 01-.79-.79.92.92 0 010-1"
                    style={{
                        WebkitTransformOrigin: 473.129,
                        MsTransformOrigin: 473.129,
                        transformOrigin: 473.129,
                    }}
                    id="elr69sbubmat"
                    fill="#7C3B29"
                    className="animable"
                ></path>
                <path
                    d="M476 206.45c-.44 0-.4 2.94-2.89 5.08s-5.64 1.87-5.66 2.29c0 .18.71.56 2 .57a7.36 7.36 0 004.73-1.74 6.4 6.4 0 002.23-4.26c.09-1.23-.25-1.96-.41-1.94z"
                    style={{
                        WebkitTransformOrigin: 471.937,
                        MsTransformOrigin: 471.937,
                        transformOrigin: 471.937,
                    }}
                    id="elflgtiwxulgj"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M476.54 173.7c.28.73 3 .33 6.19.66s5.8 1.16 6.21.48c.19-.32-.27-1-1.33-1.7a10.83 10.83 0 00-9.45-.88c-1.16.5-1.74 1.09-1.62 1.44z"
                    style={{
                        WebkitTransformOrigin: 482.753,
                        MsTransformOrigin: 482.753,
                        transformOrigin: 482.753,
                    }}
                    id="el0c7h9c2edhr"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M451.53 176.43c.49.6 2.36-.07 4.61-.14s4.17.34 4.6-.31c.19-.32-.13-.94-1-1.51a6.69 6.69 0 00-7.42.37c-.75.65-1 1.29-.79 1.59z"
                    style={{
                        WebkitTransformOrigin: 456.126,
                        MsTransformOrigin: 456.126,
                        transformOrigin: 456.126,
                    }}
                    id="eliu5yrsvs429"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M441.83 152c3 7 9.89 17.38 17.43 18.3a22.31 22.31 0 0020-8.48c1.14 5.62 7.38 8.6 13 9.53 4 .66 8.22.7 12-.81s7-4.79 7.59-8.79-5.09-13.86-9.08-14.6"
                    style={{
                        WebkitTransformOrigin: 476.861,
                        MsTransformOrigin: 476.861,
                        transformOrigin: 476.861,
                    }}
                    id="elgpv8tp1u6pk"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M493.68 166a12.26 12.26 0 006.09 16.15c-2.78 3.45-3.28 8.34-2.22 12.65s3.49 8.16 6.1 11.75c0 0-6.78 9.81 6.87 17 0 0 9.58-3 5.3-17.41A4.28 4.28 0 01516 203a5.4 5.4 0 012.37-1.87 15.69 15.69 0 006.19-21.13 10.26 10.26 0 01-1.33-3c-.27-1.62-1.51-5.85-1-7.4 2.93-8.09-.84-18.14-10.33-23.13-7.61-4-17.14-4.67-23 1.66"
                    style={{
                        WebkitTransformOrigin: 507.665,
                        MsTransformOrigin: 507.665,
                        transformOrigin: 507.665,
                    }}
                    id="elu5scbnh8po9"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M546.67 323.31l13-50.85-36.47-20.07-35.2 54.26-31.89-52.76-32.85 14.87a9.89 9.89 0 00-4.89 4.86L388.65 354l40.16 13 4.6-18.63 5.29 32.17-15.28 84.42 131.13-.48-23.24-86.67 3.23-19.33z"
                    style={{
                        WebkitTransformOrigin: 474.16,
                        MsTransformOrigin: 474.16,
                        transformOrigin: 474.16,
                    }}
                    id="ellq4fxs5xlpg"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <g
                    style={{
                        WebkitTransformOrigin: 489.94,
                        MsTransformOrigin: 489.94,
                        transformOrigin: 489.94,
                    }}
                    id="els2gw8rueww"
                    className="animable"
                    opacity="0.3"
                >
                    <path
                        id="elm5xpo3qs2fo"
                        d="M436.58 389.22c9 1.52 17.1-6.45 26.22-6.52 8.41-.06 15.39 6.53 23.58 8.44 3.61.84 7.55.81 10.67 2.79 2.4 1.52 4 4 5.64 6.31a56.33 56.33 0 0032.9 21.63c2 .45 6.48 2 7.71.31L542 417l-1.14-15.71-43.94-32-50.15 2.46z"
                        style={{
                            WebkitTransformOrigin: 489.94,
                            MsTransformOrigin: 489.94,
                            transformOrigin: 489.94,
                        }}
                        className="animable"
                    ></path>
                </g>
                <path
                    style={{
                        WebkitTransformOrigin: 519.335,
                        MsTransformOrigin: 519.335,
                        transformOrigin: 519.335,
                    }}
                    id="elrxvgo5kmxzg"
                    fill="#263238"
                    d="M505.77 315.63H532.9V320.12H505.77z"
                    className="animable"
                ></path>
                <path
                    d="M534.74 370.49c11 3.9 23 3.31 34.48 1.62 2.73-.41 5.58-.93 7.73-2.66.72-.57 2.46-2 2.43-2.38-.08-1.05-2-2.45-3.09-3.32a36.94 36.94 0 00-29.79-7 22.08 22.08 0 00-7.78 3c-2.33 1.56-3.79 2.42-4.59 5.11"
                    style={{
                        WebkitTransformOrigin: 556.755,
                        MsTransformOrigin: 556.755,
                        transformOrigin: 556.755,
                    }}
                    id="elknabikomph8"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <g
                    style={{
                        WebkitTransformOrigin: 556.755,
                        MsTransformOrigin: 556.755,
                        transformOrigin: 556.755,
                    }}
                    id="eln3v6nmqf79j"
                    className="animable"
                    opacity="0.3"
                >
                    <path
                        id="el5ijozlzmmyd"
                        d="M534.74 370.49c11 3.9 23 3.31 34.48 1.62 2.73-.41 5.58-.93 7.73-2.66.72-.57 2.46-2 2.43-2.38-.08-1.05-2-2.45-3.09-3.32a36.94 36.94 0 00-29.79-7 22.08 22.08 0 00-7.78 3c-2.33 1.56-3.79 2.42-4.59 5.11"
                        style={{
                            WebkitTransformOrigin: 556.755,
                            MsTransformOrigin: 556.755,
                            transformOrigin: 556.755,
                        }}
                        className="animable"
                    ></path>
                </g>
                <path
                    d="M579.38 367.07s-11.52-68.71-12.23-74.84c-1.79-15.2-7.51-20.06-7.51-20.06L532.9 354l1.85 16.49s8.45-12.72 44.63-3.42z"
                    style={{
                        WebkitTransformOrigin: 556.14,
                        MsTransformOrigin: 556.14,
                        transformOrigin: 556.14,
                    }}
                    id="elz6tci3ti9za"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <path
                    d="M564.64 311.89a11.55 11.55 0 01-.5 1.7c-.34 1.09-.91 2.64-1.65 4.54a104.48 104.48 0 01-7 14.31 99.13 99.13 0 01-9.18 13c-1.31 1.56-2.41 2.8-3.2 3.62a13.65 13.65 0 01-1.26 1.24 11 11 0 011.11-1.38c.74-.86 1.8-2.13 3.07-3.72a115.19 115.19 0 009-13.06 120.12 120.12 0 007.12-14.14c.78-1.88 1.4-3.41 1.8-4.47a12 12 0 01.69-1.64z"
                    style={{
                        WebkitTransformOrigin: 553.245,
                        MsTransformOrigin: 553.245,
                        transformOrigin: 553.245,
                    }}
                    id="elzpx5o7ig8gn"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M438.53 378.83a.66.66 0 01-.06-.22c0-.18-.07-.4-.12-.67-.09-.63-.23-1.48-.4-2.56-.38-2.27-.91-5.47-1.57-9.4C435 358 433 347.1 430.82 335s-4.18-23-5.63-31l-1.65-9.4c-.16-1.07-.3-1.93-.4-2.56l-.07-.67a.58.58 0 010-.23.78.78 0 01.06.22c0 .18.08.4.13.66.12.63.28 1.48.49 2.55.44 2.26 1.05 5.44 1.81 9.36 1.51 7.91 3.58 18.85 5.79 30.94s4.12 23.05 5.4 31c.64 4 1.11 7.2 1.41 9.43.13 1.09.23 1.95.31 2.58 0 .27 0 .49.06.67a1 1 0 010 .28z"
                    style={{
                        WebkitTransformOrigin: 430.799,
                        MsTransformOrigin: 430.799,
                        transformOrigin: 430.799,
                    }}
                    id="el71iep8xf3a"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M548.65 296a4 4 0 01-.14.77c-.12.55-.28 1.28-.49 2.19-.45 1.95-1.08 4.69-1.86 8-1.59 6.79-3.79 16.16-6.12 26.54s-4.36 19.79-5.7 26.63c-.66 3.42-1.2 6.19-1.53 8.11-.16.92-.3 1.65-.4 2.21a3.8 3.8 0 01-.17.76 4.55 4.55 0 01.07-.78q.12-.84.3-2.22c.27-1.94.75-4.72 1.37-8.15 1.25-6.86 3.21-16.29 5.55-26.68s4.59-19.74 6.27-26.51c.84-3.34 1.53-6.06 2-8 .24-.9.44-1.62.58-2.17a3.81 3.81 0 01.27-.7z"
                    style={{
                        WebkitTransformOrigin: 540.445,
                        MsTransformOrigin: 540.445,
                        transformOrigin: 540.445,
                    }}
                    id="el6q6dmvbf2a6"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M447.66 257.41a1.7 1.7 0 01.22.31l.62 1c.55.86 1.33 2.1 2.33 3.69l8.48 13.59 28 45.37h-.43l1.32-1.87c1.43-2 2.83-4 4.15-5.84v.34l-25.84-42.85c-3.24-5.41-5.85-9.78-7.66-12.82l-2.05-3.47-.52-.91a1.59 1.59 0 01-.17-.32 2.34 2.34 0 01.21.29l.56.89c.5.8 1.22 2 2.13 3.43 1.85 3 4.51 7.35 7.8 12.73l26 42.76.08.14-.09.14c-1.33 1.86-2.73 3.84-4.15 5.84l-1.33 1.87-.23.32-.2-.33-27.89-45.5c-3.52-5.79-6.37-10.47-8.35-13.74-1-1.6-1.72-2.86-2.25-3.74l-.57-1a1.77 1.77 0 01-.17-.32z"
                    style={{
                        WebkitTransformOrigin: 470.275,
                        MsTransformOrigin: 470.275,
                        transformOrigin: 470.275,
                    }}
                    id="elowytx1kb70a"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M523.17 252.09a1 1 0 01-.15.29l-.51.82-2 3.14-7.4 11.55-24.94 38.6v-.28c1.1 1.8 2.27 3.72 3.46 5.65l1.12 1.83h-.44c5.34-8 10.26-15.66 14.77-22.61s8.62-13.16 12.2-18.28 6.57-9.18 8.67-12l2.45-3.17.65-.82a2.16 2.16 0 01.23-.26 1.55 1.55 0 01-.19.3l-.61.84c-.56.76-1.35 1.85-2.37 3.23-2 2.81-5 6.9-8.53 12s-7.63 11.36-12.1 18.33S498.11 306 492.77 314l-.23.34-.21-.35-1.12-1.83-3.45-5.65-.09-.13.09-.14 25.08-38.51 7.53-11.46 2.06-3.09.54-.79z"
                    style={{
                        WebkitTransformOrigin: 509.475,
                        MsTransformOrigin: 509.475,
                        transformOrigin: 509.475,
                    }}
                    id="elogjz6o51oak"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M451.56 348.28a8.75 8.75 0 00-11.08 3.72 9.1 9.1 0 001.2 10c2.37 2.52 8.11 4.24 10.78 1.2z"
                    style={{
                        WebkitTransformOrigin: 445.983,
                        MsTransformOrigin: 445.983,
                        transformOrigin: 445.983,
                    }}
                    id="elyv2irqpa49a"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    d="M451.56 348.28a7.15 7.15 0 01.13 1.06c.06.78.15 1.8.25 3.05.19 2.73.45 6.46.75 10.84v.1l-.06.07a5.63 5.63 0 01-4.67 1.7 10.39 10.39 0 01-5.11-1.74 7.74 7.74 0 01-3.11-4.11 10 10 0 01-.33-4.8 8.12 8.12 0 011.85-3.94 9.09 9.09 0 013-2.27 8.62 8.62 0 015.37-.63 6.54 6.54 0 011.88.67c-.05 0-.66-.25-1.91-.47a8.67 8.67 0 00-5.18.77 8 8 0 00-4.57 5.95 9.4 9.4 0 00.34 4.56 7.25 7.25 0 002.91 3.84 10 10 0 004.85 1.66 5.16 5.16 0 004.28-1.5l-.06.17c-.22-4.34-.4-8-.54-10.74l-.12-3.1a8.48 8.48 0 01.05-1.14z"
                    style={{
                        WebkitTransformOrigin: 445.974,
                        MsTransformOrigin: 445.974,
                        transformOrigin: 445.974,
                    }}
                    id="elz0c2kma4ffm"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M444.41 348.28s2.85-58.74 4.32-67.16 5.25-22 11.2-30.27c5.69-7.87 6.25-8.42 6.25-8.42l-.38 7.33a103 103 0 00-11.42 30.47c-3.17 16.64-5.35 68-5.35 68z"
                    style={{
                        WebkitTransformOrigin: 455.295,
                        MsTransformOrigin: 455.295,
                        transformOrigin: 455.295,
                    }}
                    id="el0jejlk5jp1b6"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M527.89 358.78a13 13 0 01-4.86-1l.76-1.85a9.89 9.89 0 006.47.51 7.33 7.33 0 004.73-4.3 10.8 10.8 0 00.1-6.26 37.78 37.78 0 00-1.49-4.47c-.25-.65-.5-1.3-.74-2-4.2-11.81-3.47-25-2.83-36.69l2 .11c-.63 11.47-1.34 24.48 2.73 35.91.23.65.47 1.28.71 1.92a38.84 38.84 0 011.58 4.71 12.59 12.59 0 01-.18 7.45 9.22 9.22 0 01-6 5.5 10.23 10.23 0 01-2.98.46z"
                    style={{
                        WebkitTransformOrigin: 530.279,
                        MsTransformOrigin: 530.279,
                        transformOrigin: 530.279,
                    }}
                    id="elhz4pdd95pf9"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M527.7 359.66c-3.34 0-6.26-1.57-8.8-4.71-3.3-4.06-3.83-14.13-4.29-23-.16-3.18-.32-6.18-.6-8.36-1-7.68-5.39-18-5.43-18.09l1.83-.79c.19.43 4.56 10.66 5.58 18.63.29 2.25.45 5.29.62 8.5.42 8.16.95 18.32 3.84 21.87 4.36 5.37 9.65 5.32 17.15-.17l1.18 1.62c-4.13 2.99-7.78 4.5-11.08 4.5z"
                    style={{
                        WebkitTransformOrigin: 523.68,
                        MsTransformOrigin: 523.68,
                        transformOrigin: 523.68,
                    }}
                    id="elbpxiya5jmm7"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    d="M534.75 355.25a11.69 11.69 0 011.53-2.88 4 4 0 012.58-1.63 2.51 2.51 0 012.56 1.41 3 3 0 01-.46 3 4.2 4.2 0 01-2.55 1.42 11.34 11.34 0 01-2.91 0"
                    style={{
                        WebkitTransformOrigin: 538.191,
                        MsTransformOrigin: 538.191,
                        transformOrigin: 538.191,
                    }}
                    id="elme9tm7l470j"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M514.79 268.1a64.82 64.82 0 0113.5 34.9h4.16a65.29 65.29 0 00-16.23-39.36 61.57 61.57 0 002.29-10.17c.92-7.81-7.65-12.54-7.65-12.54v5.92a6.91 6.91 0 013.5 6.14c-.19 4.21-3.35 13.16-6.44 20.88a46.29 46.29 0 00-3.41 20c.29 8.75 3.71 12.72 3.71 12.72l4.13-1.75s-2.47-3.09-3.54-11.54c-.82-6.46 1.09-11.51 2.75-16.18.84-2.32 2.05-5.52 3.23-9.02z"
                    style={{
                        WebkitTransformOrigin: 518.449,
                        MsTransformOrigin: 518.449,
                        transformOrigin: 518.449,
                    }}
                    id="elbknkj4czkfr"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M395.27 355.9l-5 19.07a18.13 18.13 0 004.37 17.38c.27.27.55.54.83.79a18.85 18.85 0 0019.53 3.47L466.79 376l-7.65-23.35-39.21 11.17z"
                    style={{
                        WebkitTransformOrigin: 428.2,
                        MsTransformOrigin: 428.2,
                        transformOrigin: 428.2,
                    }}
                    id="el4ejf4oq4thu"
                    fill="#A36957"
                    className="animable"
                ></path>
                <path
                    d="M437.79 324.12l9.39 50a4.47 4.47 0 004.57 3.65l71.74-2.77a4.49 4.49 0 004.31-4.63l-1.64-47.24a4.47 4.47 0 00-4.48-4.32h-79.49a4.47 4.47 0 00-4.4 5.31z"
                    style={{
                        WebkitTransformOrigin: 482.756,
                        MsTransformOrigin: 482.756,
                        transformOrigin: 482.756,
                    }}
                    id="elc9wzwx3b5vj"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M516.17 344.48a6.66 6.66 0 00-6.22 4.24c-1 2.71-2.56 5.87-4.24 6.78-3.11 1.7-8.49 3.06-11.31 1.67s-14.14-11.56-16.12-10.43-3.68 3.67-1.7 5.94S489 361.73 487 364s-24-7.7-27.43-6.82-5.37 3-3.39 4.33 17 7 17.81 9c0 0-22.62-5.94-23.47-4.52s-2.26 3.67 0 4.52 21.78 5.94 23.47 6.79a41 41 0 008.73 2.54c.61 0 5 1.49 9.11 2.89a19.94 19.94 0 0014.07-.37l2.29-.94a9 9 0 005.57-8.85l-.46-7.71 2.47-6.37z"
                    style={{
                        WebkitTransformOrigin: 482.734,
                        MsTransformOrigin: 482.734,
                        transformOrigin: 482.734,
                    }}
                    id="el612lzwolibe"
                    fill="#A36957"
                    className="animable"
                ></path>
                <path
                    d="M498.05 383.81s41.28 37.37 55.18 37.48c14.65.11 22.9-15.09 21.34-24.54-.84-5-3-31.39-3-31.39-9.81-2.68-24.47-3.88-34.92 3.07l3.81 15.38-27.56-13.32z"
                    style={{
                        WebkitTransformOrigin: 536.404,
                        MsTransformOrigin: 536.404,
                        transformOrigin: 536.404,
                    }}
                    id="el42u42ywnybf"
                    fill="#A36957"
                    className="animable"
                ></path>
                <path
                    d="M579.38 367.07a2 2 0 01-.47-.08l-1.34-.32c-1.15-.28-2.82-.69-4.89-1.16a68.34 68.34 0 00-16.4-1.9 57.36 57.36 0 00-9 1 32.68 32.68 0 00-7.1 2.09 17.58 17.58 0 00-4.24 2.61c-.89.77-1.32 1.27-1.36 1.24a1.63 1.63 0 01.28-.39 11 11 0 01.95-1 16.16 16.16 0 014.22-2.79 30.72 30.72 0 017.16-2.23 54.46 54.46 0 019.12-1.07 63.06 63.06 0 0116.49 2.06c2.07.52 3.73 1 4.87 1.33l1.3.41c.26.13.42.18.41.2z"
                    style={{
                        WebkitTransformOrigin: 556.98,
                        MsTransformOrigin: 556.98,
                        transformOrigin: 556.98,
                    }}
                    id="elfjeo7yqhdq"
                    fill="#263238"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--Desk--inject-5"
                style={{
                    WebkitTransformOrigin: 375,
                    MsTransformOrigin: 375,
                    transformOrigin: 375,
                }}
                className="animable animator-hidden"
            >
                <path
                    d="M699.8 464.7c0 .14-145.43.26-324.78.26s-324.82-.12-324.82-.26 145.4-.26 324.82-.26 324.78.12 324.78.26z"
                    style={{
                        WebkitTransformOrigin: 375,
                        MsTransformOrigin: 375,
                        transformOrigin: 375,
                    }}
                    id="el3i5qf2jhoq"
                    fill="#263238"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--Plant--inject-5"
                style={{
                    WebkitTransformOrigin: 610.987,
                    MsTransformOrigin: 610.987,
                    transformOrigin: 610.987,
                }}
                className="animable animator-hidden"
            >
                <path
                    d="M613 419.87c2.11 3 6.15 1.95 8 .12s2.63-4.47 3.33-7c1.61-5.74 3.22-11.77 1.95-17.59a9.67 9.67 0 00-2.28-4.76 5.12 5.12 0 00-4.85-1.58c-2 .56-3.28 2.57-4.18 4.47a42 42 0 00-4 18c0 2.89.38 5.93 2 8.3"
                    style={{
                        WebkitTransformOrigin: 618.854,
                        MsTransformOrigin: 618.854,
                        transformOrigin: 618.854,
                    }}
                    id="el4qunn1lz58b"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <g
                    style={{
                        WebkitTransformOrigin: 618.854,
                        MsTransformOrigin: 618.854,
                        transformOrigin: 618.854,
                    }}
                    id="elzab9hr70j2"
                    className="animable"
                    opacity="0.2"
                >
                    <path
                        id="eld3tzzq7acqt"
                        d="M613 419.87c2.11 3 6.15 1.95 8 .12s2.63-4.47 3.33-7c1.61-5.74 3.22-11.77 1.95-17.59a9.67 9.67 0 00-2.28-4.76 5.12 5.12 0 00-4.85-1.58c-2 .56-3.28 2.57-4.18 4.47a42 42 0 00-4 18c0 2.89.38 5.93 2 8.3"
                        style={{
                            WebkitTransformOrigin: 618.854,
                            MsTransformOrigin: 618.854,
                            transformOrigin: 618.854,
                        }}
                        className="animable"
                    ></path>
                </g>
                <path
                    d="M620.94 434.87a18.1 18.1 0 0111.18-1.45 9.3 9.3 0 015.55 2.43c1.39 1.51 1.67 4.19.1 5.51a5.33 5.33 0 01-3.48.92c-3 0-6.25-.51-8.6 1.29-1.34 1-2.22 2.72-3.83 3.23a3.83 3.83 0 01-4.21-1.83 6.51 6.51 0 01-.51-4.81 7.31 7.31 0 013.8-5.29z"
                    style={{
                        WebkitTransformOrigin: 627.865,
                        MsTransformOrigin: 627.865,
                        transformOrigin: 627.865,
                    }}
                    id="elfofgm5niiln"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <path
                    d="M607.34 424.18a10.81 10.81 0 001.61-10 19.17 19.17 0 00-6-8.51 32 32 0 00-10.61-6.15 11.41 11.41 0 00-4.75-.77 5 5 0 00-4 2.45c-1.09 2.12 0 4.68 1.16 6.77a80.45 80.45 0 007 10.51c2.09 2.66 4.5 5.29 7.67 6.47s6.47 1 8.13-1.19"
                    style={{
                        WebkitTransformOrigin: 596.333,
                        MsTransformOrigin: 596.333,
                        transformOrigin: 596.333,
                    }}
                    id="elk47a87157ka"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <path
                    d="M613.23 464.72a6.39 6.39 0 00.18-1.36c.09-1 .2-2.21.33-3.68a52.17 52.17 0 01.79-5.42 41.81 41.81 0 011.91-6.39 23.29 23.29 0 013.22-5.8 12.14 12.14 0 014.09-3.46 11.61 11.61 0 013.46-1.11 7 7 0 001.34-.2 6.19 6.19 0 00-1.36 0 10.25 10.25 0 00-3.62 1 12 12 0 00-4.31 3.48 23.11 23.11 0 00-3.34 5.92 39.69 39.69 0 00-1.9 6.5 46.31 46.31 0 00-.67 5.48c-.11 1.57-.14 2.84-.16 3.71a6.39 6.39 0 00.04 1.33z"
                    style={{
                        WebkitTransformOrigin: 620.861,
                        MsTransformOrigin: 620.861,
                        transformOrigin: 620.861,
                    }}
                    id="el096lf2cv31ws"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M613.46 461.88a2.58 2.58 0 000-.63v-1.79-6.59c.1-5.56.52-13.24 1.38-21.68s2-16 3.12-21.49c.26-1.37.51-2.6.76-3.68s.43-2 .62-2.76.3-1.29.41-1.75a.31.31 0 10-.11 0c-.14.45-.3 1-.51 1.72s-.45 1.67-.72 2.75-.55 2.3-.84 3.67a204.7 204.7 0 00-3.29 21.52c-.86 8.46-1.22 16.15-1.21 21.73 0 2.79.07 5 .15 6.6 0 .72.09 1.32.12 1.79a3 3 0 00.12.59z"
                    style={{
                        WebkitTransformOrigin: 616.537,
                        MsTransformOrigin: 616.537,
                        transformOrigin: 616.537,
                    }}
                    id="el7tnglbf60kb"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M613.38 447a11.58 11.58 0 000-1.87c-.08-1.2-.26-2.94-.62-5.07a69.64 69.64 0 00-4.88-16.06 46.45 46.45 0 00-9.19-14.07 21.63 21.63 0 00-2.15-2c-.33-.28-.62-.55-.91-.77l-.84-.56a11.78 11.78 0 00-1.58-1 56 56 0 015.2 4.57 49 49 0 019 14 69.77 69.77 0 013.17 8.64 74.5 74.5 0 011.82 7.31c.4 2.1.64 3.82.78 5a13.34 13.34 0 00.2 1.88z"
                    style={{
                        WebkitTransformOrigin: 603.314,
                        MsTransformOrigin: 603.314,
                        transformOrigin: 603.314,
                    }}
                    id="el7zboj850ut5"
                    fill="#263238"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--speech-bubble--inject-5"
                style={{
                    WebkitTransformOrigin: 584.271,
                    MsTransformOrigin: 584.271,
                    transformOrigin: 584.271,
                }}
                className="animable animator-hidden"
            >
                <rect
                    id="elgwrty2komk8"
                    width="8.47"
                    height="48.45"
                    x="565.26"
                    y="78.62"
                    fill="#E0E0E0"
                    className="animable"
                    rx="4.11"
                    style={{
                        WebkitTransformOrigin: 569.495,
                        MsTransformOrigin: 569.495,
                        transformOrigin: 569.495,
                    }}
                ></rect>
                <rect
                    id="elgwv3lpo00q"
                    width="8.47"
                    height="33.97"
                    x="565.26"
                    y="93.1"
                    fill="#FF725E"
                    className="animable"
                    rx="4.11"
                    style={{
                        WebkitTransformOrigin: 569.495,
                        MsTransformOrigin: 569.495,
                        transformOrigin: 569.495,
                    }}
                ></rect>
                <rect
                    id="ell5w1vvnvbeh"
                    width="8.47"
                    height="48.45"
                    x="579.13"
                    y="78.62"
                    fill="#E0E0E0"
                    className="animable"
                    rx="4.11"
                    style={{
                        WebkitTransformOrigin: 583.365,
                        MsTransformOrigin: 583.365,
                        transformOrigin: 583.365,
                    }}
                ></rect>
                <rect
                    id="elwvep0kc6dwd"
                    width="8.47"
                    height="26.46"
                    x="579.13"
                    y="100.61"
                    fill="#FF725E"
                    className="animable"
                    rx="4.11"
                    style={{
                        WebkitTransformOrigin: 583.365,
                        MsTransformOrigin: 583.365,
                        transformOrigin: 583.365,
                    }}
                ></rect>
                <rect
                    id="elivwoernk68d"
                    width="8.47"
                    height="48.45"
                    x="594.82"
                    y="78.62"
                    fill="#E0E0E0"
                    className="animable"
                    rx="4.11"
                    style={{
                        WebkitTransformOrigin: 599.055,
                        MsTransformOrigin: 599.055,
                        transformOrigin: 599.055,
                    }}
                ></rect>
                <rect
                    id="elphcu21brzfn"
                    width="8.47"
                    height="39.7"
                    x="594.82"
                    y="87.38"
                    fill="#FF725E"
                    className="animable"
                    rx="4.11"
                    style={{
                        WebkitTransformOrigin: 599.055,
                        MsTransformOrigin: 599.055,
                        transformOrigin: 599.055,
                    }}
                ></rect>
                <path
                    d="M569.62 127.08s.38 0 1.06-.2a4 4 0 002.35-1.82 3.93 3.93 0 00.57-2.08v-2.68-6.52-17V84.16a9.4 9.4 0 00-.17-2.57 3.91 3.91 0 00-3.93-2.71 3.87 3.87 0 00-3.73 2.93 13 13 0 00-.12 2.6v38.78a3.91 3.91 0 00.69 2 4.13 4.13 0 002.46 1.68c.69.14 1.07.11 1.07.14a3.23 3.23 0 01-1.09 0 4.2 4.2 0 01-2.61-1.66 4.14 4.14 0 01-.77-2.15v-2.68V114c0-4.84 0-10.59-.06-17V87v-3.92a5.67 5.67 0 01.13-1.4 4.4 4.4 0 014.24-3.32 4.58 4.58 0 012.75.79 4.48 4.48 0 011.67 2.28 5.2 5.2 0 01.2 1.4v13.96c0 6.38 0 12.13-.06 17v9.2a4.24 4.24 0 01-.64 2.18 4.09 4.09 0 01-2.93 1.83 3.16 3.16 0 01-1.08.08z"
                    style={{
                        WebkitTransformOrigin: 569.834,
                        MsTransformOrigin: 569.834,
                        transformOrigin: 569.834,
                    }}
                    id="el127mhalbxxcc"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M583.48 127.08s.38 0 1.06-.2a4 4 0 002.93-3.9v-2.68-6.52-17V84.16a9.4 9.4 0 00-.18-2.57 4 4 0 00-7.66.22 13.06 13.06 0 00-.11 2.6V97.04c0 6.38 0 12.13-.06 17v9.19a4.1 4.1 0 00.69 2 4.14 4.14 0 002.47 1.68c.68.14 1.07.11 1.06.14a3.22 3.22 0 01-1.09 0 4.16 4.16 0 01-3.37-3.81v-2.68-6.52c0-4.84 0-10.59-.05-17v-14a5.22 5.22 0 01.13-1.4 4.39 4.39 0 014.24-3.32 4.53 4.53 0 012.74.79 4.44 4.44 0 011.68 2.28 4.82 4.82 0 01.19 1.4v14c0 6.38 0 12.13-.05 17v9.2a4.16 4.16 0 01-.65 2.18 4.08 4.08 0 01-2.5 1.82 3.22 3.22 0 01-1.47.09z"
                    style={{
                        WebkitTransformOrigin: 583.658,
                        MsTransformOrigin: 583.658,
                        transformOrigin: 583.658,
                    }}
                    id="elqatmvrsogt"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M599.17 127.08s.38 0 1.06-.2a4 4 0 002.93-3.9v-2.68-6.52c0-4.84 0-10.59-.06-17V84.16a9.4 9.4 0 00-.18-2.57 4 4 0 00-7.66.22 13.83 13.83 0 00-.12 2.6V97c0 6.38 0 12.13-.06 17v9.19a4 4 0 00.69 2 4.15 4.15 0 002.46 1.68c.69.14 1.07.11 1.07.14a3.22 3.22 0 01-1.09 0 4.16 4.16 0 01-3.37-3.81v-2.68V114 97 83a5.22 5.22 0 01.13-1.4 4.39 4.39 0 014.24-3.32 4.42 4.42 0 014.42 3.07 4.82 4.82 0 01.19 1.4V122.95a4.16 4.16 0 01-.65 2.18 4.08 4.08 0 01-2.5 1.82 3.22 3.22 0 01-1.5.13z"
                    style={{
                        WebkitTransformOrigin: 599.328,
                        MsTransformOrigin: 599.328,
                        transformOrigin: 599.328,
                    }}
                    id="el2nxnd166f0o"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M584.28 47.28a5.71 5.71 0 01.91 0l2.69.07c.59 0 1.26 0 2 .09l2.37.34 2.77.39 3.09.77a50.13 50.13 0 0115 6.54 52.92 52.92 0 0124.32 39.79 54.54 54.54 0 01.14 7.25c-.08 1.23-.06 2.47-.24 3.71s-.37 2.48-.56 3.74a53.33 53.33 0 01-5 14.76 56.49 56.49 0 01-9.69 13.27 55.6 55.6 0 01-13.89 10 50.66 50.66 0 01-16.93 5.2 33.88 33.88 0 01-4.52.38 38.48 38.48 0 01-4.56.08 53.28 53.28 0 01-27.35-8.81l.55.06-18.54 7.44-1.09.44.31-1.14 5.45-19.82.09.48a53.15 53.15 0 01-9.89-22.65A48.06 48.06 0 01531 98a37.81 37.81 0 01.52-5.57c.15-.91.29-1.82.43-2.72s.43-1.75.64-2.62A53.09 53.09 0 01553.27 57a50.59 50.59 0 0112.31-6.49l2.77-1 2.65-.71 2.4-.6c.78-.15 1.52-.23 2.22-.33 1.4-.18 2.63-.42 3.71-.48l2.73-.09h1.66a3.5 3.5 0 01.57 0 2 2 0 01-.57.08l-1.65.13-2.71.18c-1.07.09-2.29.36-3.68.56a52.76 52.76 0 00-42.16 39.11c-.2.86-.46 1.71-.62 2.58s-.27 1.77-.4 2.67a36.47 36.47 0 00-.49 5.47 47.32 47.32 0 00.75 11.38 52.23 52.23 0 009.76 22.15l.16.23-.07.26-5.41 19.84-.78-.7q9.06-3.65 18.53-7.46l.29-.12.26.17a52.27 52.27 0 0026.74 8.61 39 39 0 004.46-.08 32.39 32.39 0 004.41-.37 49.48 49.48 0 0016.56-5.06 54.8 54.8 0 0013.61-9.74 56 56 0 009.47-13 52.42 52.42 0 005-14.45q.28-1.85.57-3.66c.18-1.21.16-2.43.25-3.63a54.35 54.35 0 00-.12-7.12A52.34 52.34 0 00612.74 56 50.33 50.33 0 00598 49.38l-3.05-.81-2.74-.45-2.36-.39c-.72-.08-1.38-.1-2-.14l-2.68-.2a5.05 5.05 0 01-.89-.11z"
                    style={{
                        WebkitTransformOrigin: 584.271,
                        MsTransformOrigin: 584.271,
                        transformOrigin: 584.271,
                    }}
                    id="eltsh0wkc8ikr"
                    fill="#263238"
                    className="animable"
                ></path>
            </g>
            <defs>
                <filter id="active" height="200%">
                    <feMorphology
                        in="SourceAlpha"
                        operator="dilate"
                        radius="2"
                        result="DILATED"
                    ></feMorphology>
                    <feFlood
                        floodColor="#32DFEC"
                        floodOpacity="1"
                        result="PINK"
                    ></feFlood>
                    <feComposite
                        in="PINK"
                        in2="DILATED"
                        operator="in"
                        result="OUTLINE"
                    ></feComposite>
                    <feMerge>
                        <feMergeNode in="OUTLINE"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                </filter>
                <filter id="hover" height="200%">
                    <feMorphology
                        in="SourceAlpha"
                        operator="dilate"
                        radius="2"
                        result="DILATED"
                    ></feMorphology>
                    <feFlood floodColor="red" floodOpacity="0.5" result="PINK"></feFlood>
                    <feComposite
                        in="PINK"
                        in2="DILATED"
                        operator="in"
                        result="OUTLINE"
                    ></feComposite>
                    <feMerge>
                        <feMergeNode in="OUTLINE"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                    <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
                </filter>
            </defs>
        </svg>
    );
}
